const translations = {
  'en-US': {
    'sidebar.newChat': 'New Chat',
    'sidebar.searchPlaceholder': 'Search chats...',
    'sidebar.nav.chat': 'Chat',
    'sidebar.nav.media': 'Media',
    'sidebar.nav.news': 'News',
    'sidebar.nav.projects': 'Projects',
    'sidebar.nav.workspace': 'Workspace',
    'sidebar.nav.admin': 'Admin',
    'sidebar.section.chats': 'Chats',
    'sidebar.emptySearch': 'No chats found for "{{term}}"',
    'sidebar.button.share': 'Share Chat',
    'sidebar.button.delete': 'Delete Chat',
    'sidebar.profile.signIn': 'Sign In',
    'sidebar.profile.viewProfile': 'View profile: {{username}}',
    'sidebar.profile.settings': 'Settings',
    'sidebar.profile.info': 'Info',
    'sidebar.profile.signOut': 'Sign Out',
    'sidebar.collapseTitle': 'Collapse Sidebar',
    'sidebar.copySuccess': 'Share link copied to clipboard!',
    'sidebar.copyFailure': 'Could not copy share link.',
    'sidebar.mobile.expand': 'Expand Menu',
    'sidebar.mobile.collapse': 'Collapse Menu',
    'chat.defaultTitle': 'New Chat',
    'chat.newConversation': 'New Conversation',
    'chat.emptyHeading': 'No chat available',
    'chat.emptySubheading': 'Creating a new chat...',
    'chat.emptyRefresh': 'Refresh Page',
    'composer.placeholder.image': 'Enter prompt for image generation...',
    'composer.placeholder.video': 'Enter prompt for video generation...',
    'composer.placeholder.flowchart': 'Describe the flowchart you want to create...',
    'composer.placeholder.waiting': 'Waiting for response...',
    'composer.placeholder.processing': 'Processing file...',
    'composer.placeholder.attachedSingle': 'Attached: {{name}}. Add text or send.',
    'composer.placeholder.attachedMultiple': 'Attached: {{count}} files. Add text or send.',
    'composer.placeholder.default': 'Type message, paste image, or attach file...',
    'composer.liveModeActive': 'Live Mode Active',
    'composer.liveModeStart': 'Start Live Mode',
    'composer.chip.thinking': 'Thinking',
    'composer.chip.search': 'Search',
    'composer.chip.deepResearch': 'Deep Research',
    'composer.chip.analysis': 'Analysis',
    'composer.chip.create': 'Create',
    'composer.chip.createImage': 'Create image',
    'composer.chip.createVideo': 'Create video',
    'composer.chip.createFlowchart': 'Create flowchart',
    'composer.analysis.tooltip': 'Code Execution – analyze data, generate charts, and more',
    'composer.toolbar.open': 'Open Toolbar',
    'composer.toolbar.close': 'Close Toolbar',
    'composer.toolbar.moreActions': 'More actions',
    'composer.toolbar.equationEditor': 'Equation Editor',
    'composer.toolbar.whiteboard': 'Whiteboard',
    'composer.toolbar.graphing': 'Graphing Calculator',
    'composer.toolbar.flowchart': 'Flowchart',
    'composer.toolbar.sandbox3d': '3D Sandbox',
    'composer.menu.modeTitle': 'Select Mode',
    'composer.menu.createTitle': 'Create Content',
    'composer.menu.default': 'Default',
    'composer.menu.instant': 'Instant',
    'composer.menu.image': 'Image',
    'composer.menu.video': 'Video',
    'composer.menu.flowchart': 'Flowchart',
    'composer.menu.sandbox3d': '3D Sandbox',
    'news.title': 'News',
    'news.refresh': 'Refresh',
    'news.refreshing': 'Refreshing...',
    'news.filters.top': 'Top Stories',
    'news.filters.saved': 'Saved',
    'news.filters.tech': 'Technology',
    'news.filters.sports': 'Sports',
    'news.filters.finance': 'Finance',
    'news.filters.art': 'Art & Culture',
    'news.filters.tv': 'TV & Entertainment',
    'news.filters.politics': 'Politics',
    'news.loadingList': 'Loading the latest articles...',
    'news.error.title': 'Unable to load news',
    'news.error.retry': 'Try Again',
    'news.error.fetch': 'We could not fetch the selected news category.',
    'news.error.articleContent': 'Unable to load the full article. Showing a preview instead.',
    'news.empty.saved': 'You have not saved any articles yet.',
    'news.empty.category': 'No articles in this category yet. Check back soon.',
    'news.article.noContent': 'No content available for this article.',
    'news.article.loading': 'Loading article...',
    'news.summary.couldNotGenerate': 'Could not generate a summary for this article.',
    'news.summary.failed': 'We had trouble summarizing this article. Please try again later.',
    'news.loadingArticle': 'Loading full article...',
    'news.generatingSummary': 'Generating AI summary...',
    'news.fullArticleTag': 'Full Article',
    'news.readOriginal': 'Read the original article on {{source}} →',
    'news.detail.byAuthor': 'By {{author}}',
    'news.detail.source': 'Source: {{source}}',
    'news.detail.published': 'Published {{time}}',
    'news.category.uncategorized': 'Uncategorized',
    'projects.title': 'Projects',
    'projects.subtitle': 'Organize your work with custom instructions and knowledge files',
    'projects.createButton': 'Create project',
    'projects.searchPlaceholder': 'Search projects...',
    'projects.emptyTitle': 'Create your first project',
    'projects.emptyDescription': 'Projects help you organize conversations with custom instructions and knowledge files that provide context across all chats.',
    'projects.noResults': 'No projects found',
    'projects.noResultsDesc': 'No projects match "{{term}}"',
    'projects.noDescription': 'No description',
    'projects.chats': 'chats',
    'projects.files': 'files',
    'projects.delete': 'Delete project',
    'projects.filter.all': 'All',
    'projects.filter.starred': 'Starred',
    'projects.modal.title': 'Create a new project',
    'projects.modal.subtitle': 'Set up custom instructions and context for your conversations',
    'projects.modal.nameLabel': 'Project name',
    'projects.modal.namePlaceholder': 'Enter a name for your project',
    'projects.modal.descriptionLabel': 'Description',
    'projects.modal.descriptionPlaceholder': 'What is this project about?',
    'projects.modal.icon': 'Icon',
    'projects.modal.color': 'Color',
    'projects.modal.instructions': 'Custom instructions',
    'projects.modal.instructionsHelp': 'These instructions will be included with every message in this project. Use them to set context, define how the AI should respond, or provide relevant background information.',
    'projects.modal.instructionsPlaceholder': 'e.g., "You are helping me write a fantasy novel. The story is set in a medieval world with magic..."',
    'projects.modal.untitled': 'Untitled Project',
    'projects.modal.noDescription': 'No description',
    'projects.modal.create': 'Create project',
    'projects.instructions': 'Instructions',
    'projects.instructionsPlaceholder': 'Add custom instructions for this project...',
    'projects.noInstructions': 'No custom instructions set. Click Edit to add instructions that will be included with every message.',
    'projects.knowledge': 'Knowledge',
    'projects.addKnowledge': 'Add files',
    'projects.newChat': 'New chat',
    'projects.notFound': 'Project not found',
    'projects.notFoundDesc': 'This project may have been deleted.',
    'projects.backToProjects': 'Back to projects',
    'projects.startConversation': 'Start a conversation',
    'projects.conversationContext': 'Your project instructions and knowledge files will be included as context in every message.',
    'projects.selectChat': 'Select or start a chat',
    'common.optional': 'optional',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.edit': 'Edit',
    'models.noModels': 'No models available',
    'models.searchPlaceholder': 'Search models...',
    'models.provider.google': 'Google AI',
    'models.provider.openrouter': 'OpenRouter',
    'models.provider.backend': 'Backend',
    'models.provider.local': 'Local',
    'models.provider.anthropic': 'Anthropic',
    'models.provider.openai': 'OpenAI',
    'models.provider.nvidia': 'NVIDIA',
    'models.provider.generic': 'AI',
    'models.selectPlaceholder': 'Select a model',
    'models.sectionHeader': 'Choose a model',
    'chat.history.noMessages': 'No messages yet',
    'chat.history.noContent': 'No content',
    'chat.attachments.uploaded': 'Uploaded content',
    'chat.list.untitled': 'Chat {{id}}',
    'chat.status.thinking': 'Thinking...',
    'chat.labels.request': 'Request',
    'chat.labels.query': 'Query',
    'chat.labels.prompt': 'Prompt',
    'chat.labels.error': 'Error',
    'chat.labels.parameters': 'Parameters',
    'chat.labels.result': 'Result',
    'chat.labels.yourRequest': 'your request',
    'chat.labels.yourQuery': 'your query',
    'chat.labels.yourPrompt': 'your prompt',
    'chat.errors.apiKeys.notConfigured': 'API keys are not configured.',
    'chat.errors.apiKeys.instructions': 'Add OPENROUTER_API_KEY, GEMINI_API_KEY, ANTHROPIC_API_KEY, or OPENAI_API_KEY in .dev.vars to enable live responses.',
    'chat.errors.generic': 'Failed to generate response. Please try again.',
    'chat.flowchart.creating': 'Creating flowchart for: "{{prompt}}"...',
    'chat.flowchart.openBuilder': 'Open Flowchart Builder',
    'chat.flowchart.instructionsHint': 'Flowchart instructions generated. Click "{{buttonLabel}}" to visualize and edit.',
    'chat.flowchart.failed': 'Flowchart Generation Failed',
    'chat.research.performing': 'Performing deep research...',
    'chat.research.initializing': 'Initializing...',
    'chat.research.results': 'Deep Research Results',
    'chat.research.questionsLabel': 'Research Questions ({{count}}):',
    'chat.research.analyzedBy': 'Analyzed by {{count}} research agents',
    'chat.research.failed': 'Deep Research Failed',
    'chat.image.generating': 'Generating image for: "{{prompt}}"...',
    'chat.image.failed': 'Image Generation Failed',
    'chat.video.generating': 'Generating video for: "{{prompt}}"...',
    'chat.video.failed': 'Video Generation Failed',
    'chat.actions.copyInstructions': 'Copy Instructions',
    'chat.actions.copyResults': 'Copy Results',
    'chat.actions.copyUrl': 'Copy URL',
    'chat.actions.readAloud': 'Read aloud',
    'chat.actions.stopSpeaking': 'Stop speaking',
    'chat.actions.load3d': 'Load in 3D',
    'chat.share.title': 'AI Chat Message',
    'chat.thinking.header.thoughtsAndTools': 'Thoughts & Tools',
    'chat.thinking.header.thoughts': 'Thoughts',
    'chat.thinking.header.tools': 'Tool Activity',
    'chat.thinking.toolActivity': '🛠️ Tool Activity',
    'chat.thinking.section.reasoning': '💭 Reasoning',
    'chat.thinking.tool.parameters': 'Parameters:',
    'chat.thinking.tool.result': 'Result:',
    'chat.thinking.tool.error': 'Error:',
    'chat.thinking.tool.unknown': 'Unknown Tool',
    'chat.thinking.tool.status.pending': 'Pending',
    'chat.thinking.tool.status.executing': 'Running',
    'chat.thinking.tool.status.completed': 'Completed',
    'chat.thinking.tool.status.error': 'Error',
    'liveMode.status.connecting': 'Connecting...',
    'liveMode.status.starting': 'Starting...',
    'liveMode.status.listening': 'Listening',
    'liveMode.status.thinking': 'Thinking',
    'liveMode.status.ready': 'Ready',
    'liveMode.errors.cameraDenied': 'Camera access denied',
    'liveMode.errors.screenDenied': 'Screen share denied',
    'liveMode.errors.connection': 'Connection error',
    'liveMode.controls.close': 'Close Live Mode',
    'liveMode.controls.mic.mute': 'Mute Microphone',
    'liveMode.controls.mic.unmute': 'Unmute Microphone',
    'liveMode.controls.camera.on': 'Turn On Camera',
    'liveMode.controls.camera.off': 'Turn Off Camera',
    'liveMode.controls.screen.start': 'Share Screen',
    'liveMode.controls.screen.stop': 'Stop Sharing',
    'account.title': 'Account',
    'account.alert.invalidImageType': 'Please select an image file',
    'account.alert.imageTooLarge': 'Please select an image smaller than 5MB',
    'account.emailFallback': 'No email provided',
    'account.memberSince': 'Member since',
    'account.theme': 'Theme',
    'account.themeDefault': 'Default',
    'account.status': 'Status',
    'account.statusAdmin': 'Admin',
    'account.statusMember': 'Member',
    'account.button.switchToAdmin': 'Switch to Admin',
    'account.button.logoutAdmin': 'Logout Admin',
    'account.button.signOut': 'Sign Out',
    'workspace.title': 'Models',
    'workspace.searchPlaceholder': 'Search models...',
    'workspace.button.newModel': 'New Model',
    'workspace.model.baseLabel': 'Based on:',
    'workspace.model.byLabel': 'By',
    'workspace.actions.edit': 'Edit',
    'workspace.actions.share': 'Share model',
    'workspace.actions.moreOptions': 'More options',
    'workspace.share.confirm': 'Share this model? Anyone with the link can preview the system prompt and copy this model into their own workspace.',
    'workspace.share.success': 'Share link copied to clipboard.',
    'workspace.share.failure': 'Could not create share link.',
    'workspace.share.copyManual': 'Copy this share link:',
    'workspace.share.copyFailure': 'Could not auto-copy — link shown above.',
    'workspace.share.signInRequired': 'Sign in to share models.',
    'workspace.modal.titleEdit': 'Edit Model',
    'workspace.modal.titleCreate': 'Create New Model',
    'workspace.modal.fieldName': 'Model Name',
    'workspace.modal.fieldDescription': 'Description',
    'workspace.modal.fieldAvatar': 'Avatar',
    'workspace.modal.fieldBaseModel': 'Base Model',
    'workspace.modal.helperBaseModel': 'Select which AI model this custom model should use',
    'workspace.modal.fieldSystemPrompt': 'System Prompt',
    'workspace.modal.placeholderExamples': 'e.g. Code Assistant, Creative Writer',
    'workspace.modal.placeholderDescription': 'Briefly describe what this model specializes in...',
    'workspace.modal.placeholderSystemPrompt': 'Enter the system prompt that defines how this model should behave...',
    'workspace.modal.status.loadingModels': 'Loading models...',
    'workspace.modal.button.delete': 'Delete Model',
    'workspace.modal.button.cancel': 'Cancel',
    'workspace.modal.button.save': 'Save Changes',
    'workspace.modal.button.create': 'Create Model',
    'workspace.baseModelFallback': 'Unknown',
    'media.title': 'Media',
    'media.placeholder': 'Content for the Media page will go here.',
    'flowchart.titleSuffix': 'Flowchart',
    'flowchart.subtitle': 'Build, drop, or upload',
    'flowchart.sidebar.nodesLabel': 'Nodes',
    'flowchart.sidebar.helper': 'Drag onto the canvas, or double-click a chip to drop one in the middle.',
    'flowchart.sidebar.dragOrDouble': 'Drag onto the canvas, or double-click to add at center',
    'flowchart.node.start': 'Start',
    'flowchart.node.process': 'Process',
    'flowchart.node.decision': 'Decision',
    'flowchart.node.end': 'End',
    'flowchart.toolbar.save': 'Save & Insert',
    'flowchart.toolbar.clear': 'Clear',
    'flowchart.toolbar.upload': 'Upload',
    'flowchart.toolbar.layout': 'Auto-layout',
    'flowchart.empty.title': 'Build a flowchart',
    'flowchart.empty.description': 'Drag node chips from the left, or click Upload to bring in your own image or JSON. Connect nodes by dragging from one handle to another. Double-click a node to rename.',
    'flowchart.error.exportFailed': 'Export failed.',
    'flowchart.error.empty': 'Add at least one node before saving.',
    'flowchart.error.invalidJson': 'Could not read the JSON file.',
    'flowchart.error.unsupportedType': 'Unsupported file type. Use an image or JSON.',
    'flowchart.error.aiParseFailed': 'Could not read AI-generated flowchart instructions.',
    'graph.titleSuffix': 'Graph',
    'graph.placeholder': 'Enter expression...',
    'graph.button.addExpression': '+ Add Expression',
    'graph.controls.reset': 'Reset View',
    'graph.controls.zoomIn': 'Zoom In',
    'graph.controls.zoomOut': 'Zoom Out',
    'sandbox3d.title': 'SCULPTOR 3D',
    'sandbox3d.outliner.title': 'OUTLINER ({{count}})',
    'sandbox3d.gizmoHint': 'Use Mouse to Orbit • Click to Select • Drag Gizmo to Move',
    'sandbox3d.toolbar.addBox': '+ Box',
    'sandbox3d.toolbar.addSphere': '+ Sphere',
    'sandbox3d.toolbar.addCylinder': '+ Cyl',
    'sandbox3d.toolbar.addTorus': '+ Torus',
    'sandbox3d.toolbar.delete': 'Delete',
    'sandbox3d.toolbar.save': 'Save',
    'sandbox3d.section.properties': 'PROPERTIES',
    'sandbox3d.section.transform': 'TRANSFORM',
    'sandbox3d.section.material': 'MATERIAL',
    'sandbox3d.label.position': 'Position',
    'sandbox3d.label.rotation': 'Rotation',
    'sandbox3d.label.scale': 'Scale',
    'sandbox3d.label.color': 'Color',
    'sandbox3d.label.hex': 'Hex',
    'sandbox3d.noObjectSelected': 'No object selected',
    'sandbox3d.types.box': 'box',
    'sandbox3d.types.sphere': 'sphere',
    'sandbox3d.types.cylinder': 'cylinder',
    'sandbox3d.types.torus': 'torus',
    'equation.title': 'Equation Editor',
    'equation.preview.hint': 'Type math naturally... (e.g. "1/2", "sqrt(x)", "alpha")',
    'equation.input.placeholder': 'Type math here... e.g. "x^2 + y^2 = r^2" or "1/2"',
    'equation.preview.typing': 'Typing: "{{input}}" → Renders as LaTeX',
    'equation.button.cancel': 'Cancel',
    'equation.button.insert': 'Insert Equation',
    'whiteboard.tool.pencil': 'Pencil',
    'whiteboard.tool.square': 'Square',
    'whiteboard.tool.circle': 'Circle',
    'whiteboard.tool.line': 'Line',
    'whiteboard.tool.text': 'Text',
    'whiteboard.tool.eraser': 'Eraser',
    'whiteboard.tool.undo': 'Undo',
    'whiteboard.tool.redo': 'Redo',
    'whiteboard.tool.clear': 'Clear',
    'whiteboard.action.export': 'Export',
    'whiteboard.action.send': 'Send',
    'imageSelector.label': 'Image:',
    'imageSelector.placeholder': 'Select model',
    'settings.title': 'Settings',
    'settings.close': 'Close',
    'settings.saveButton': 'Save Changes',
    'settings.nav.general': 'General',
    'settings.nav.appearance': 'Appearance',
    'settings.nav.interface': 'Interface',
    'settings.nav.chats': 'Chats',
    'settings.nav.accessibility': 'Accessibility',
    'settings.nav.developer': 'Developer',
    'settings.nav.about': 'About',
    'settings.sections.general': 'General',
    'settings.sections.appearance': 'Appearance',
    'settings.sections.interface': 'Interface Settings',
    'settings.sections.chats': 'Chat Settings',
    'settings.sections.accessibility': 'Accessibility',
    'settings.sections.developer': 'Developer',
    'settings.sections.about': 'About',
    'settings.general.theme.label': 'Theme',
    'settings.general.language.label': 'Language',
    'settings.general.notifications.label': 'Notifications',
    'settings.themeOptions.light': 'Light',
    'settings.themeOptions.dark': 'Dark',
    'settings.themeOptions.oled': 'OLED',
    'settings.themeOptions.ocean': 'Ocean',
    'settings.themeOptions.forest': 'Forest',
    'settings.themeOptions.sunset': 'Sunset',
    'settings.themeOptions.sunrise': 'Sunrise',
    'settings.themeOptions.pride': 'Pride',
    'settings.themeOptions.trans': 'Trans',
    'settings.themeOptions.bisexual': 'Bisexual',
    'settings.themeOptions.lakeside': 'Lakeside',
    'settings.themeOptions.retro': 'Retro',
    'settings.themeOptions.custom': 'Custom',
    'settings.languageOptions.en-US': 'English (US)',
    'settings.languageOptions.fr': 'Français',
    'settings.languageOptions.es': 'Español',
    'settings.languageOptions.de': 'Deutsch',
    'settings.languageOptions.zh': '中文',
    'settings.appearance.fontSize.label': 'Font Size',
    'settings.fontSize.small': 'Small',
    'settings.fontSize.medium': 'Medium',
    'settings.fontSize.large': 'Large',
    'settings.appearance.fontFamily.label': 'Font Family',
    'settings.fontFamily.system': 'System Default',
    'settings.fontFamily.inter': 'Space Mono',
    'settings.fontFamily.roboto': 'Roboto',
    'settings.fontFamily.opensans': 'Open Sans',
    'settings.fontFamily.montserrat': 'Montserrat',
    'settings.fontFamily.lato': 'Lato',
    'settings.fontFamily.caveat': 'Caveat',
    'settings.fontFamily.georgia': 'Georgia',
    'settings.fontFamily.merriweather': 'Merriweather',
    'settings.appearance.sidebarStyle.label': 'Sidebar Style',
    'settings.appearance.sidebarStyle.floating': 'Floating',
    'settings.appearance.sidebarStyle.traditional': 'Traditional',
    'settings.appearance.sidebarStyle.description': 'Choose between a floating sidebar with rounded corners or a traditional sidebar that touches the screen edge.',
    'settings.appearance.accent.color': 'Accent Color',
    'settings.appearance.accent.description': 'Accent colors update buttons, bubbles, toggles, and other highlights throughout the interface.',
    'settings.chats.profiles.toggleVisibility.label': 'Toggle profile icon visibility',
    'settings.chats.profiles.toggleVisibility.description': 'Show profile icon in chats',
    'settings.chats.features.label': 'Message Features',
    'settings.chats.features.timestamps': 'Show message timestamps',
    'settings.chats.features.modelIcons': 'Show model icons in messages',
    'settings.chats.features.codeHighlighting': 'Enable code syntax highlighting',
    'settings.chats.sending.label': 'Message Sending',
    'settings.chats.sending.sendWithEnter': 'Send message with Enter (use Shift+Enter for a new line)',
    'settings.chats.alignment.label': 'Message Alignment',
    'settings.chats.alignment.left': 'Left',
    'settings.chats.alignment.right': 'Right',
    'settings.interface.layout.label': 'Layout',
    'settings.interface.layout.autoCollapse': 'Auto-collapse sidebar when chatting',
    'settings.interface.layout.focusMode': 'Focus mode (hide UI elements while typing)',
    'settings.interface.layout.showGreeting': 'Show greeting message on empty chat',
    'settings.interface.bubbles.label': 'Message Bubbles',
    'settings.interface.bubbles.modern': 'Modern (rounded)',
    'settings.interface.bubbles.classic': 'Classic (rectangle)',
    'settings.interface.bubbles.minimal': 'Minimal (no bubbles)',
    'settings.interface.spacing.label': 'Message Spacing',
    'settings.interface.spacing.compact': 'Compact',
    'settings.interface.spacing.comfortable': 'Comfortable',
    'settings.interface.spacing.spacious': 'Spacious',
    'settings.accessibility.visual.label': 'Visual Comfort',
    'settings.accessibility.visual.highContrast': 'High contrast mode',
    'settings.accessibility.visual.reducedMotion': 'Reduce animations and motion',
    'settings.accessibility.textSpacing.label': 'Text Spacing',
    'settings.accessibility.textSpacing.normal': 'Normal',
    'settings.accessibility.textSpacing.relaxed': 'Relaxed',
    'settings.accessibility.textSpacing.loose': 'Loose',
    'settings.developer.onboarding.label': 'Onboarding',
    'settings.developer.onboarding.description': 'Reset the onboarding flow for testing so the welcome tutorial plays again.',
    'settings.developer.onboarding.restart': 'Restart Onboarding',
    'settings.about.logoAlt.default': 'Sculptor logo',
    'settings.about.logoAlt.lakeside': 'Andromeda logo',
    'settings.about.logoTitle.default': 'Sculptor',
    'settings.about.logoTitle.lakeside': 'Andromeda',
    'settings.about.madeWith': 'Made with',
    'settings.about.prideWord': 'Pride',
    'settings.about.teamMessage': 'From the Andromeda team, with ❤️',
    'settings.about.version': 'Sculptor Alpha 0.0.6',
    'settings.mobile.chatBehavior': 'Chat behavior',
    'settings.mobile.themeDescription': 'Choose your preferred color scheme',
    'settings.mobile.fontSizeDescription': 'Adjust text size for better readability',
    'settings.mobile.messageStyle.label': 'Message style',
    'settings.mobile.messageStyle.description': 'Choose how chat bubbles look',
    'settings.mobile.sendWithEnter.title': 'Send with Enter',
    'settings.mobile.sendWithEnter.description': 'Press Enter to send messages',
    'settings.mobile.timestamps.title': 'Show timestamps',
    'settings.mobile.timestamps.description': 'Display the time beneath each message',
    'settings.mobile.modelIcons.title': 'Show model icons',
    'settings.mobile.modelIcons.description': 'Display the AI model avatar beside replies',
    'settings.mobile.greeting.title': 'Show greeting',
    'settings.mobile.greeting.description': 'Display a welcome message on empty chats',
    'settings.mobile.codeHighlighting.title': 'Code highlighting',
    'settings.mobile.codeHighlighting.description': 'Render syntax highlighting for code blocks',
    'settings.mobile.accessibility.highContrastDescription': 'Increase contrast for better visibility',
    'settings.mobile.accessibility.reducedMotionDescription': 'Minimize animations and transitions'
  },
  fr: {
    'sidebar.newChat': 'Nouvelle discussion',
    'sidebar.searchPlaceholder': 'Rechercher des discussions...',
    'sidebar.nav.chat': 'Discussion',
    'sidebar.nav.media': 'Médias',
    'sidebar.nav.news': 'Actualités',
    'sidebar.nav.projects': 'Projets',
    'sidebar.nav.workspace': 'Espace de travail',
    'sidebar.nav.admin': 'Admin',
    'sidebar.section.chats': 'Discussions',
    'sidebar.emptySearch': 'Aucune discussion trouvée pour « {{term}} »',
    'sidebar.button.share': 'Partager la discussion',
    'sidebar.button.delete': 'Supprimer la discussion',
    'sidebar.profile.signIn': 'Se connecter',
    'sidebar.profile.viewProfile': 'Voir le profil : {{username}}',
    'sidebar.profile.settings': 'Paramètres',
    'sidebar.profile.info': 'Info',
    'sidebar.profile.signOut': 'Se déconnecter',
    'sidebar.collapseTitle': 'Réduire la barre latérale',
    'sidebar.copySuccess': 'Lien de partage copié dans le presse-papiers !',
    'sidebar.copyFailure': 'Impossible de copier le lien de partage.',
    'sidebar.mobile.expand': 'Déplier le menu',
    'sidebar.mobile.collapse': 'Replier le menu',
    'chat.defaultTitle': 'Nouvelle discussion',
    'chat.newConversation': 'Nouvelle conversation',
    'chat.emptyHeading': 'Aucune discussion disponible',
    'chat.emptySubheading': 'Création d\'une nouvelle discussion...',
    'chat.emptyRefresh': 'Actualiser la page',
    'composer.placeholder.image': 'Saisissez une invite pour générer une image...',
    'composer.placeholder.video': 'Saisissez une invite pour générer une vidéo...',
    'composer.placeholder.flowchart': 'Décrivez le diagramme que vous souhaitez créer...',
    'composer.placeholder.waiting': 'En attente de la réponse...',
    'composer.placeholder.processing': 'Traitement du fichier...',
    'composer.placeholder.attachedSingle': 'Pièce jointe : {{name}}. Ajoutez du texte ou envoyez.',
    'composer.placeholder.attachedMultiple': 'Pièces jointes : {{count}} fichiers. Ajoutez du texte ou envoyez.',
    'composer.placeholder.default': 'Tapez un message, collez une image ou joignez un fichier...',
    'composer.liveModeActive': 'Mode direct activé',
    'composer.liveModeStart': 'Démarrer le mode direct',
    'composer.chip.thinking': 'Réflexion',
    'composer.chip.search': 'Recherche',
    'composer.chip.deepResearch': 'Recherche approfondie',
    'composer.chip.analysis': 'Analyse',
    'composer.chip.create': 'Créer',
    'composer.chip.createImage': 'Créer une image',
    'composer.chip.createVideo': 'Créer une vidéo',
    'composer.chip.createFlowchart': 'Créer un organigramme',
    'composer.analysis.tooltip': 'Exécution de code – analyser des données, générer des graphiques, etc.',
    'composer.toolbar.open': 'Ouvrir la barre d\'outils',
    'composer.toolbar.close': 'Fermer la barre d\'outils',
    'composer.toolbar.moreActions': 'Plus d\'actions',
    'composer.toolbar.equationEditor': 'Éditeur d\'équations',
    'composer.toolbar.whiteboard': 'Tableau blanc',
    'composer.toolbar.graphing': 'Calculatrice graphique',
    'composer.toolbar.flowchart': 'Organigramme',
    'composer.toolbar.sandbox3d': 'Sandbox 3D',
    'composer.menu.modeTitle': 'Choisir le mode',
    'composer.menu.createTitle': 'Créer du contenu',
    'composer.menu.default': 'Par défaut',
    'composer.menu.instant': 'Instantané',
    'composer.menu.image': 'Image',
    'composer.menu.video': 'Vidéo',
    'composer.menu.flowchart': 'Organigramme',
    'composer.menu.sandbox3d': 'Bac à sable 3D',
    'news.title': 'Actualités',
    'news.refresh': 'Actualiser',
    'news.refreshing': 'Actualisation...',
    'news.filters.top': 'À la une',
    'news.filters.saved': 'Enregistrés',
    'news.filters.tech': 'Technologie',
    'news.filters.sports': 'Sports',
    'news.filters.finance': 'Finance',
    'news.filters.art': 'Art et culture',
    'news.filters.tv': 'Télé & divertissement',
    'news.filters.politics': 'Politique',
    'news.loadingList': 'Chargement des derniers articles...',
    'news.error.title': 'Impossible de charger les actualités',
    'news.error.retry': 'Réessayer',
    'news.error.fetch': 'Nous n\'avons pas pu récupérer la catégorie d\'actualités sélectionnée.',
    'news.error.articleContent': 'Impossible de charger l\'article complet. Aperçu affiché à la place.',
    'news.empty.saved': 'Vous n\'avez pas encore enregistré d\'article.',
    'news.empty.category': 'Aucun article dans cette catégorie pour le moment. Revenez bientôt.',
    'news.article.noContent': 'Aucun contenu disponible pour cet article.',
    'news.article.loading': 'Chargement de l\'article...',
    'news.summary.couldNotGenerate': 'Impossible de générer un résumé pour cet article.',
    'news.summary.failed': 'Nous n\'avons pas pu résumer cet article. Réessayez plus tard.',
    'news.loadingArticle': 'Chargement de l\'article complet...',
    'news.generatingSummary': 'Génération du résumé IA...',
    'news.fullArticleTag': 'Article complet',
    'news.readOriginal': 'Lire l\'article original sur {{source}} →',
    'news.detail.byAuthor': 'Par {{author}}',
    'news.detail.source': 'Source : {{source}}',
    'news.detail.published': 'Publié le {{time}}',
    'news.category.uncategorized': 'Non classé',
    'projects.title': 'Projets',
    'projects.createButton': 'Nouveau projet',
    'projects.searchPlaceholder': 'Rechercher des projets...',
    'projects.emptyTitle': 'Commencez votre premier projet',
    'projects.emptyDescription': 'Organisez vos idées, fichiers et invites dans des espaces dédiés.',
    'models.noModels': 'Aucun modèle disponible',
    'models.searchPlaceholder': 'Rechercher des modèles...',
    'models.provider.google': 'Google AI',
    'models.provider.openrouter': 'OpenRouter',
    'models.provider.backend': 'Serveur',
    'models.provider.local': 'Local',
    'models.provider.anthropic': 'Anthropic',
    'models.provider.openai': 'OpenAI',
    'models.provider.nvidia': 'NVIDIA',
    'models.provider.generic': 'IA',
    'models.selectPlaceholder': 'Choisir un modèle',
    'models.sectionHeader': 'Choisissez un modèle',
    'chat.history.noMessages': 'Aucun message pour l\'instant',
    'chat.history.noContent': 'Aucun contenu',
    'chat.attachments.uploaded': 'Contenu téléversé',
    'chat.list.untitled': 'Discussion {{id}}',
    'chat.status.thinking': 'Réflexion...',
    'chat.labels.request': 'Demande',
    'chat.labels.query': 'Requête',
    'chat.labels.prompt': 'Invite',
    'chat.labels.error': 'Erreur',
    'chat.labels.parameters': 'Paramètres',
    'chat.labels.result': 'Résultat',
    'chat.labels.yourRequest': 'votre demande',
    'chat.labels.yourQuery': 'votre requête',
    'chat.labels.yourPrompt': 'votre invite',
    'chat.errors.apiKeys.notConfigured': 'Les clés API ne sont pas configurées.',
    'chat.errors.apiKeys.instructions': 'Ajoutez OPENROUTER_API_KEY, GEMINI_API_KEY, ANTHROPIC_API_KEY ou OPENAI_API_KEY dans .dev.vars pour activer les réponses en direct.',
    'chat.errors.generic': 'Échec de génération de la réponse. Veuillez réessayer.',
    'chat.flowchart.creating': 'Création d\'un organigramme pour : "{{prompt}}"...',
    'chat.flowchart.openBuilder': 'Ouvrir le créateur d\'organigrammes',
    'chat.flowchart.instructionsHint': 'Instructions d\'organigramme générées. Cliquez sur "{{buttonLabel}}" pour visualiser et modifier.',
    'chat.flowchart.failed': 'Échec de la génération de l\'organigramme',
    'chat.research.performing': 'Recherche approfondie en cours...',
    'chat.research.initializing': 'Initialisation...',
    'chat.research.results': 'Résultats de la recherche approfondie',
    'chat.research.questionsLabel': 'Questions de recherche ({{count}}) :',
    'chat.research.analyzedBy': 'Analysé par {{count}} agents de recherche',
    'chat.research.failed': 'La recherche approfondie a échoué',
    'chat.image.generating': 'Génération d\'image pour : "{{prompt}}"...',
    'chat.image.failed': 'Échec de la génération d\'image',
    'chat.video.generating': 'Génération de vidéo pour : "{{prompt}}"...',
    'chat.video.failed': 'Échec de la génération de vidéo',
    'chat.actions.copyInstructions': 'Copier les instructions',
    'chat.actions.copyResults': 'Copier les résultats',
    'chat.actions.copyUrl': 'Copier l\'URL',
    'chat.actions.readAloud': 'Lire à voix haute',
    'chat.actions.stopSpeaking': 'Arrêter la lecture',
    'chat.actions.load3d': 'Charger en 3D',
    'chat.share.title': 'Message de discussion IA',
    'chat.thinking.header.thoughtsAndTools': 'Réflexions et outils',
    'chat.thinking.header.thoughts': 'Réflexions',
    'chat.thinking.header.tools': 'Activité des outils',
    'chat.thinking.toolActivity': '🛠️ Activité des outils',
    'chat.thinking.section.reasoning': '💭 Raisonnement',
    'chat.thinking.tool.parameters': 'Paramètres :',
    'chat.thinking.tool.result': 'Résultat :',
    'chat.thinking.tool.error': 'Erreur :',
    'chat.thinking.tool.unknown': 'Outil inconnu',
    'chat.thinking.tool.status.pending': 'En attente',
    'chat.thinking.tool.status.executing': 'En cours',
    'chat.thinking.tool.status.completed': 'Terminé',
    'chat.thinking.tool.status.error': 'Erreur',
    'liveMode.status.connecting': 'Connexion...',
    'liveMode.status.starting': 'Démarrage...',
    'liveMode.status.listening': 'Écoute',
    'liveMode.status.thinking': 'Réflexion',
    'liveMode.status.ready': 'Prêt',
    'liveMode.errors.cameraDenied': 'Accès à la caméra refusé',
    'liveMode.errors.screenDenied': 'Partage d\'écran refusé',
    'liveMode.errors.connection': 'Erreur de connexion',
    'liveMode.controls.close': 'Fermer le mode direct',
    'liveMode.controls.mic.mute': 'Couper le micro',
    'liveMode.controls.mic.unmute': 'Rétablir le micro',
    'liveMode.controls.camera.on': 'Activer la caméra',
    'liveMode.controls.camera.off': 'Désactiver la caméra',
    'liveMode.controls.screen.start': 'Partager l\'écran',
    'liveMode.controls.screen.stop': 'Arrêter le partage',
    'account.title': 'Compte',
    'account.alert.invalidImageType': 'Veuillez sélectionner un fichier image',
    'account.alert.imageTooLarge': 'Veuillez choisir une image de moins de 5 Mo',
    'account.emailFallback': 'Aucun email fourni',
    'account.memberSince': 'Membre depuis',
    'account.theme': 'Thème',
    'account.themeDefault': 'Par défaut',
    'account.status': 'Statut',
    'account.statusAdmin': 'Admin',
    'account.statusMember': 'Membre',
    'account.button.switchToAdmin': 'Passer en mode admin',
    'account.button.logoutAdmin': 'Déconnexion admin',
    'account.button.signOut': 'Se déconnecter',
    'workspace.title': 'Modèles',
    'workspace.searchPlaceholder': 'Rechercher des modèles...',
    'workspace.button.newModel': 'Nouveau modèle',
    'workspace.model.baseLabel': 'Basé sur :',
    'workspace.model.byLabel': 'Par',
    'workspace.actions.edit': 'Modifier',
    'workspace.actions.moreOptions': 'Plus d\'options',
    'workspace.modal.titleEdit': 'Modifier le modèle',
    'workspace.modal.titleCreate': 'Créer un nouveau modèle',
    'workspace.modal.fieldName': 'Nom du modèle',
    'workspace.modal.fieldDescription': 'Description',
    'workspace.modal.fieldAvatar': 'Avatar',
    'workspace.modal.fieldBaseModel': 'Modèle de base',
    'workspace.modal.helperBaseModel': 'Sélectionnez le modèle IA que doit utiliser ce modèle personnalisé',
    'workspace.modal.fieldSystemPrompt': 'Prompt système',
    'workspace.modal.placeholderExamples': 'ex. Assistant Code, Rédacteur créatif',
    'workspace.modal.placeholderDescription': 'Décrivez brièvement la spécialité de ce modèle...',
    'workspace.modal.placeholderSystemPrompt': 'Entrez le prompt système définissant le comportement de ce modèle...',
    'workspace.modal.status.loadingModels': 'Chargement des modèles...',
    'workspace.modal.button.delete': 'Supprimer le modèle',
    'workspace.modal.button.cancel': 'Annuler',
    'workspace.modal.button.save': 'Enregistrer les modifications',
    'workspace.modal.button.create': 'Créer le modèle',
    'workspace.baseModelFallback': 'Inconnu',
    'media.title': 'Médias',
    'media.placeholder': 'Le contenu de la page Médias sera bientôt disponible.',
    'flowchart.titleSuffix': 'Organigramme',
    'flowchart.subtitle': 'Créer, glisser ou importer',
    'flowchart.sidebar.nodesLabel': 'Nœuds',
    'flowchart.sidebar.helper': 'Glissez sur la toile, ou double-cliquez sur une puce pour en déposer un au centre.',
    'flowchart.sidebar.dragOrDouble': 'Glissez sur la toile, ou double-cliquez pour ajouter au centre',
    'flowchart.node.start': 'Début',
    'flowchart.node.process': 'Traitement',
    'flowchart.node.decision': 'Décision',
    'flowchart.node.end': 'Fin',
    'flowchart.toolbar.save': 'Enregistrer et insérer',
    'flowchart.toolbar.clear': 'Effacer',
    'flowchart.toolbar.upload': 'Importer',
    'flowchart.toolbar.layout': 'Disposition auto',
    'flowchart.empty.title': 'Créer un organigramme',
    'flowchart.empty.description': 'Glissez des nœuds depuis la gauche, ou cliquez sur Importer pour ajouter votre propre image ou JSON. Connectez les nœuds en glissant d\'une poignée à l\'autre. Double-cliquez pour renommer.',
    'flowchart.error.exportFailed': 'Échec de l\'exportation.',
    'flowchart.error.empty': 'Ajoutez au moins un nœud avant d\'enregistrer.',
    'flowchart.error.invalidJson': 'Impossible de lire le fichier JSON.',
    'flowchart.error.unsupportedType': 'Type de fichier non pris en charge. Utilisez une image ou un JSON.',
    'flowchart.error.aiParseFailed': 'Impossible de lire les instructions générées par l\'IA.',
    'graph.titleSuffix': 'Graphique',
    'graph.placeholder': 'Saisissez l’expression...',
    'graph.button.addExpression': '+ Ajouter une expression',
    'graph.controls.reset': 'Réinitialiser la vue',
    'graph.controls.zoomIn': 'Zoomer',
    'graph.controls.zoomOut': 'Dézoomer',
    'sandbox3d.title': 'SCULPTOR 3D',
    'sandbox3d.outliner.title': 'PLAN ({{count}})',
    'sandbox3d.gizmoHint': 'Utilisez la souris pour orbiter • Cliquez pour sélectionner • Faites glisser le gizmo pour déplacer',
    'sandbox3d.toolbar.addBox': '+ Boîte',
    'sandbox3d.toolbar.addSphere': '+ Sphère',
    'sandbox3d.toolbar.addCylinder': '+ Cyl',
    'sandbox3d.toolbar.addTorus': '+ Tore',
    'sandbox3d.toolbar.delete': 'Supprimer',
    'sandbox3d.toolbar.save': 'Enregistrer',
    'sandbox3d.section.properties': 'PROPRIÉTÉS',
    'sandbox3d.section.transform': 'TRANSFORMATION',
    'sandbox3d.section.material': 'MATÉRIAU',
    'sandbox3d.label.position': 'Position',
    'sandbox3d.label.rotation': 'Rotation',
    'sandbox3d.label.scale': 'Échelle',
    'sandbox3d.label.color': 'Couleur',
    'sandbox3d.label.hex': 'Hex',
    'sandbox3d.noObjectSelected': 'Aucun objet sélectionné',
    'sandbox3d.types.box': 'boîte',
    'sandbox3d.types.sphere': 'sphère',
    'sandbox3d.types.cylinder': 'cylindre',
    'sandbox3d.types.torus': 'tore',
    'equation.title': 'Éditeur d\'équations',
    'equation.preview.hint': 'Tapez les maths naturellement... (ex. "1/2", "sqrt(x)", "alpha")',
    'equation.input.placeholder': 'Tapez les maths ici... ex. "x^2 + y^2 = r^2" ou "1/2"',
    'equation.preview.typing': 'Saisie : "{{input}}" → Rend en LaTeX',
    'equation.button.cancel': 'Annuler',
    'equation.button.insert': 'Insérer l\'équation',
    'whiteboard.tool.pencil': 'Crayon',
    'whiteboard.tool.square': 'Carré',
    'whiteboard.tool.circle': 'Cercle',
    'whiteboard.tool.line': 'Ligne',
    'whiteboard.tool.text': 'Texte',
    'whiteboard.tool.eraser': 'Gomme',
    'whiteboard.tool.undo': 'Annuler',
    'whiteboard.tool.redo': 'Rétablir',
    'whiteboard.tool.clear': 'Effacer',
    'whiteboard.action.export': 'Exporter',
    'whiteboard.action.send': 'Envoyer',
    'imageSelector.label': 'Image :',
    'imageSelector.placeholder': 'Sélectionnez un modèle',
    'settings.title': 'Paramètres',
    'settings.close': 'Fermer',
    'settings.saveButton': 'Enregistrer les modifications',
    'settings.nav.general': 'Général',
    'settings.nav.appearance': 'Apparence',
    'settings.nav.interface': 'Interface',
    'settings.nav.chats': 'Discussions',
    'settings.nav.accessibility': 'Accessibilité',
    'settings.nav.developer': 'Développeur',
    'settings.nav.about': 'À propos',
    'settings.sections.general': 'Général',
    'settings.sections.appearance': 'Apparence',
    'settings.sections.interface': 'Interface',
    'settings.sections.chats': 'Paramètres de discussion',
    'settings.sections.accessibility': 'Accessibilité',
    'settings.sections.developer': 'Développeur',
    'settings.sections.about': 'À propos',
    'settings.general.theme.label': 'Thème',
    'settings.general.language.label': 'Langue',
    'settings.general.notifications.label': 'Notifications',
    'settings.themeOptions.light': 'Clair',
    'settings.themeOptions.dark': 'Sombre',
    'settings.themeOptions.oled': 'OLED',
    'settings.themeOptions.ocean': 'Océan',
    'settings.themeOptions.forest': 'Forêt',
    'settings.themeOptions.sunset': 'Coucher de soleil',
    'settings.themeOptions.sunrise': 'Lever de soleil',
    'settings.themeOptions.pride': 'Pride',
    'settings.themeOptions.trans': 'Trans',
    'settings.themeOptions.bisexual': 'Bisexuel',
    'settings.themeOptions.lakeside': 'Bord de lac',
    'settings.themeOptions.retro': 'Rétro',
    'settings.themeOptions.custom': 'Personnalisé',
    'settings.languageOptions.en-US': 'English (US)',
    'settings.languageOptions.fr': 'Français',
    'settings.languageOptions.es': 'Español',
    'settings.languageOptions.de': 'Deutsch',
    'settings.languageOptions.zh': '中文',
    'settings.appearance.fontSize.label': 'Taille de police',
    'settings.fontSize.small': 'Petit',
    'settings.fontSize.medium': 'Moyen',
    'settings.fontSize.large': 'Grand',
    'settings.appearance.fontFamily.label': 'Police',
    'settings.fontFamily.system': 'Par défaut',
    'settings.fontFamily.inter': 'Space Mono',
    'settings.fontFamily.roboto': 'Roboto',
    'settings.fontFamily.opensans': 'Open Sans',
    'settings.fontFamily.montserrat': 'Montserrat',
    'settings.fontFamily.lato': 'Lato',
    'settings.fontFamily.caveat': 'Caveat',
    'settings.fontFamily.georgia': 'Georgia',
    'settings.fontFamily.merriweather': 'Merriweather',
    'settings.appearance.sidebarStyle.label': 'Style de barre latérale',
    'settings.appearance.sidebarStyle.floating': 'Flottante',
    'settings.appearance.sidebarStyle.traditional': 'Traditionnelle',
    'settings.appearance.sidebarStyle.description': 'Choisissez entre une barre latérale flottante aux coins arrondis ou une barre classique collée au bord de l\'écran.',
    'settings.appearance.accent.color': "Couleur d'accent",
    'settings.appearance.accent.description': "Les couleurs d'accent mettent à jour les boutons, bulles, bascules et autres points forts de l'interface.",
    'settings.chats.profiles.toggleVisibility.label': "Basculer la visibilité de l'icône de profil",
    'settings.chats.profiles.toggleVisibility.description': "Afficher l'icône de profil dans les conversations",
    'settings.chats.features.label': 'Fonctionnalités des messages',
    'settings.chats.features.timestamps': 'Afficher les horodatages',
    'settings.chats.features.modelIcons': 'Afficher les icônes de modèle',
    'settings.chats.features.codeHighlighting': 'Activer la coloration syntaxique',
    'settings.chats.sending.label': 'Envoi des messages',
    'settings.chats.sending.sendWithEnter': 'Envoyer avec Entrée (Shift+Entrée pour une nouvelle ligne)',
    'settings.chats.alignment.label': 'Alignement des messages',
    'settings.chats.alignment.left': 'Gauche',
    'settings.chats.alignment.right': 'Droite',
    'settings.interface.layout.label': 'Disposition',
    'settings.interface.layout.autoCollapse': 'Réduire automatiquement la barre latérale pendant la saisie',
    'settings.interface.layout.focusMode': "Mode concentration (masquer l'interface pendant la frappe)",
    'settings.interface.layout.showGreeting': 'Afficher le message d\'accueil sur un chat vide',
    'settings.interface.bubbles.label': 'Bulles de message',
    'settings.interface.bubbles.modern': 'Moderne (arrondies)',
    'settings.interface.bubbles.classic': 'Classique (rectangle)',
    'settings.interface.bubbles.minimal': 'Minimal (sans bulles)',
    'settings.interface.spacing.label': 'Espacement des messages',
    'settings.interface.spacing.compact': 'Compact',
    'settings.interface.spacing.comfortable': 'Confortable',
    'settings.interface.spacing.spacious': 'Aéré',
    'settings.accessibility.visual.label': 'Confort visuel',
    'settings.accessibility.visual.highContrast': 'Mode à fort contraste',
    'settings.accessibility.visual.reducedMotion': 'Réduire les animations et mouvements',
    'settings.accessibility.textSpacing.label': 'Espacement du texte',
    'settings.accessibility.textSpacing.normal': 'Normal',
    'settings.accessibility.textSpacing.relaxed': 'Relâché',
    'settings.accessibility.textSpacing.loose': 'Large',
    'settings.developer.onboarding.label': 'Parcours d\'accueil',
    'settings.developer.onboarding.description': 'Réinitialisez le parcours d\'accueil pour rejouer le tutoriel.',
    'settings.developer.onboarding.restart': 'Relancer l\'accueil',
    'settings.about.logoAlt.default': 'Logo Sculptor',
    'settings.about.logoAlt.lakeside': 'Logo Andromeda',
    'settings.about.logoTitle.default': 'Sculptor',
    'settings.about.logoTitle.lakeside': 'Andromeda',
    'settings.about.madeWith': 'Créé avec',
    'settings.about.prideWord': 'Fierté',
    'settings.about.teamMessage': 'De l\'équipe Andromeda, avec ❤️',
    'settings.about.version': 'Sculptor Alpha 0.0.6',
    'settings.mobile.chatBehavior': 'Comportement du chat',
    'settings.mobile.themeDescription': 'Choisissez votre palette de couleurs préférée',
    'settings.mobile.fontSizeDescription': 'Ajustez la taille du texte pour un meilleur confort de lecture',
    'settings.mobile.messageStyle.label': 'Style des messages',
    'settings.mobile.messageStyle.description': 'Choisissez la forme des bulles de chat',
    'settings.mobile.sendWithEnter.title': 'Envoyer avec Entrée',
    'settings.mobile.sendWithEnter.description': 'Appuyez sur Entrée pour envoyer les messages',
    'settings.mobile.timestamps.title': 'Afficher les horodatages',
    'settings.mobile.timestamps.description': 'Afficher l\'heure sous chaque message',
    'settings.mobile.modelIcons.title': 'Afficher les icônes de modèle',
    'settings.mobile.modelIcons.description': 'Afficher l\'avatar du modèle IA à côté des réponses',
    'settings.mobile.greeting.title': 'Afficher le message d\'accueil',
    'settings.mobile.greeting.description': 'Afficher un message de bienvenue dans les chats vides',
    'settings.mobile.codeHighlighting.title': 'Coloration du code',
    'settings.mobile.codeHighlighting.description': 'Appliquer la coloration syntaxique aux blocs de code',
    'settings.mobile.accessibility.highContrastDescription': 'Augmentez le contraste pour une meilleure lisibilité',
    'settings.mobile.accessibility.reducedMotionDescription': 'Réduisez les animations et transitions'
  },
  es: {
    'sidebar.newChat': 'Nuevo chat',
    'sidebar.searchPlaceholder': 'Buscar chats...',
    'sidebar.nav.chat': 'Chat',
    'sidebar.nav.media': 'Medios',
    'sidebar.nav.news': 'Noticias',
    'sidebar.nav.projects': 'Proyectos',
    'sidebar.nav.workspace': 'Área de trabajo',
    'sidebar.nav.admin': 'Admin',
    'sidebar.section.chats': 'Chats',
    'sidebar.emptySearch': 'No se encontraron chats para "{{term}}"',
    'sidebar.button.share': 'Compartir chat',
    'sidebar.button.delete': 'Eliminar chat',
    'sidebar.profile.signIn': 'Iniciar sesión',
    'sidebar.profile.viewProfile': 'Ver perfil: {{username}}',
    'sidebar.profile.settings': 'Configuración',
    'sidebar.profile.info': 'Info',
    'sidebar.profile.signOut': 'Cerrar sesión',
    'sidebar.collapseTitle': 'Contraer barra lateral',
    'sidebar.copySuccess': '¡Enlace de uso compartido copiado al portapapeles!',
    'sidebar.copyFailure': 'No se pudo copiar el enlace de uso compartido.',
    'sidebar.mobile.expand': 'Expandir menú',
    'sidebar.mobile.collapse': 'Contraer menú',
    'chat.defaultTitle': 'Nuevo chat',
    'chat.newConversation': 'Nueva conversación',
    'chat.emptyHeading': 'No hay chats disponibles',
    'chat.emptySubheading': 'Creando un nuevo chat...',
    'chat.emptyRefresh': 'Actualizar página',
    'composer.placeholder.image': 'Ingresa un prompt para generar una imagen...',
    'composer.placeholder.video': 'Ingresa un prompt para generar un video...',
    'composer.placeholder.flowchart': 'Describe el diagrama de flujo que quieres crear...',
    'composer.placeholder.waiting': 'Esperando respuesta...',
    'composer.placeholder.processing': 'Procesando archivo...',
    'composer.placeholder.attachedSingle': 'Adjunto: {{name}}. Agrega texto o envía.',
    'composer.placeholder.attachedMultiple': 'Adjuntos: {{count}} archivos. Agrega texto o envía.',
    'composer.placeholder.default': 'Escribe un mensaje, pega una imagen o adjunta un archivo...',
    'composer.liveModeActive': 'Modo en vivo activo',
    'composer.liveModeStart': 'Iniciar modo en vivo',
    'composer.chip.thinking': 'Pensando',
    'composer.chip.search': 'Buscar',
    'composer.chip.deepResearch': 'Investigacion profunda',
    'composer.chip.analysis': 'Análisis',
    'composer.chip.create': 'Crear',
    'composer.chip.createImage': 'Crear imagen',
    'composer.chip.createVideo': 'Crear video',
    'composer.chip.createFlowchart': 'Crear diagrama',
    'composer.analysis.tooltip': 'Ejecución de código: analiza datos, genera gráficos y más',
    'composer.toolbar.open': 'Abrir barra de herramientas',
    'composer.toolbar.close': 'Cerrar barra de herramientas',
    'composer.toolbar.moreActions': 'Más acciones',
    'composer.toolbar.equationEditor': 'Editor de ecuaciones',
    'composer.toolbar.whiteboard': 'Pizarra',
    'composer.toolbar.graphing': 'Calculadora gráfica',
    'composer.toolbar.flowchart': 'Diagrama',
    'composer.toolbar.sandbox3d': 'Sandbox 3D',
    'composer.menu.modeTitle': 'Seleccionar modo',
    'composer.menu.createTitle': 'Crear contenido',
    'composer.menu.default': 'Predeterminado',
    'composer.menu.instant': 'Instantáneo',
    'composer.menu.image': 'Imagen',
    'composer.menu.video': 'Video',
    'composer.menu.flowchart': 'Diagrama de flujo',
    'composer.menu.sandbox3d': 'Sandbox 3D',
    'news.title': 'Noticias',
    'news.refresh': 'Actualizar',
    'news.refreshing': 'Actualizando...',
    'news.filters.top': 'Destacadas',
    'news.filters.saved': 'Guardadas',
    'news.filters.tech': 'Tecnología',
    'news.filters.sports': 'Deportes',
    'news.filters.finance': 'Finanzas',
    'news.filters.art': 'Arte y cultura',
    'news.filters.tv': 'TV y entretenimiento',
    'news.filters.politics': 'Política',
    'news.loadingList': 'Cargando los últimos artículos...',
    'news.error.title': 'No se pudieron cargar las noticias',
    'news.error.retry': 'Intentar de nuevo',
    'news.error.fetch': 'No pudimos obtener la categoría seleccionada.',
    'news.error.articleContent': 'No se pudo cargar el artículo completo. Mostramos un resumen.',
    'news.empty.saved': 'Todavía no has guardado artículos.',
    'news.empty.category': 'No hay artículos en esta categoría. Vuelve pronto.',
    'news.article.noContent': 'No hay contenido disponible para este artículo.',
    'news.article.loading': 'Cargando artículo...',
    'news.summary.couldNotGenerate': 'No se pudo generar un resumen para este artículo.',
    'news.summary.failed': 'No pudimos resumir este artículo. Inténtalo más tarde.',
    'news.loadingArticle': 'Cargando el artículo completo...',
    'news.generatingSummary': 'Generando resumen con IA...',
    'news.fullArticleTag': 'Artículo completo',
    'news.readOriginal': 'Leer el artículo original en {{source}} →',
    'news.detail.byAuthor': 'Por {{author}}',
    'news.detail.source': 'Fuente: {{source}}',
    'news.detail.published': 'Publicado {{time}}',
    'news.category.uncategorized': 'Sin categoría',
    'projects.title': 'Proyectos',
    'projects.createButton': 'Nuevo proyecto',
    'projects.searchPlaceholder': 'Buscar proyectos...',
    'projects.emptyTitle': 'Comienza tu primer proyecto',
    'projects.emptyDescription': 'Organiza tus ideas, archivos e indicaciones en espacios dedicados.',
    'models.noModels': 'No hay modelos disponibles',
    'models.searchPlaceholder': 'Buscar modelos...',
    'models.provider.google': 'Google AI',
    'models.provider.openrouter': 'OpenRouter',
    'models.provider.backend': 'Servidor',
    'models.provider.local': 'Local',
    'models.provider.anthropic': 'Anthropic',
    'models.provider.openai': 'OpenAI',
    'models.provider.nvidia': 'NVIDIA',
    'models.provider.generic': 'IA',
    'models.selectPlaceholder': 'Selecciona un modelo',
    'models.sectionHeader': 'Elige un modelo',
    'chat.history.noMessages': 'Sin mensajes todavía',
    'chat.history.noContent': 'Sin contenido',
    'chat.attachments.uploaded': 'Contenido subido',
    'chat.list.untitled': 'Chat {{id}}',
    'chat.status.thinking': 'Pensando...',
    'chat.labels.request': 'Solicitud',
    'chat.labels.query': 'Consulta',
    'chat.labels.prompt': 'Indicador',
    'chat.labels.error': 'Error',
    'chat.labels.parameters': 'Parámetros',
    'chat.labels.result': 'Resultado',
    'chat.labels.yourRequest': 'tu solicitud',
    'chat.labels.yourQuery': 'tu consulta',
    'chat.labels.yourPrompt': 'tu indicación',
    'chat.errors.apiKeys.notConfigured': 'Las claves API no están configuradas.',
    'chat.errors.apiKeys.instructions': 'Agrega OPENROUTER_API_KEY, GEMINI_API_KEY, ANTHROPIC_API_KEY u OPENAI_API_KEY en .dev.vars para activar respuestas en vivo.',
    'chat.errors.generic': 'No se pudo generar la respuesta. Inténtalo de nuevo.',
    'chat.flowchart.creating': 'Creando diagrama para: "{{prompt}}"...',
    'chat.flowchart.openBuilder': 'Abrir creador de diagramas',
    'chat.flowchart.instructionsHint': 'Se generaron instrucciones del diagrama. Haz clic en "{{buttonLabel}}" para visualizar y editar.',
    'chat.flowchart.failed': 'Error al generar el diagrama',
    'chat.research.performing': 'Realizando investigación profunda...',
    'chat.research.initializing': 'Iniciando...',
    'chat.research.results': 'Resultados de la investigación profunda',
    'chat.research.questionsLabel': 'Preguntas de investigación ({{count}}):',
    'chat.research.analyzedBy': 'Analizado por {{count}} agentes de investigación',
    'chat.research.failed': 'La investigación profunda falló',
    'chat.image.generating': 'Generando imagen para: "{{prompt}}"...',
    'chat.image.failed': 'Error al generar la imagen',
    'chat.video.generating': 'Generando video para: "{{prompt}}"...',
    'chat.video.failed': 'Error al generar el video',
    'chat.actions.copyInstructions': 'Copiar instrucciones',
    'chat.actions.copyResults': 'Copiar resultados',
    'chat.actions.copyUrl': 'Copiar URL',
    'chat.actions.readAloud': 'Leer en voz alta',
    'chat.actions.stopSpeaking': 'Detener la lectura',
    'chat.actions.load3d': 'Cargar en 3D',
    'chat.share.title': 'Mensaje de chat de IA',
    'chat.thinking.header.thoughtsAndTools': 'Pensamientos y herramientas',
    'chat.thinking.header.thoughts': 'Pensamientos',
    'chat.thinking.header.tools': 'Actividad de herramientas',
    'chat.thinking.toolActivity': '🛠️ Actividad de herramientas',
    'chat.thinking.section.reasoning': '💭 Razonamiento',
    'chat.thinking.tool.parameters': 'Parámetros:',
    'chat.thinking.tool.result': 'Resultado:',
    'chat.thinking.tool.error': 'Error:',
    'chat.thinking.tool.unknown': 'Herramienta desconocida',
    'chat.thinking.tool.status.pending': 'Pendiente',
    'chat.thinking.tool.status.executing': 'En ejecución',
    'chat.thinking.tool.status.completed': 'Completado',
    'chat.thinking.tool.status.error': 'Error',
    'liveMode.status.connecting': 'Conectando...',
    'liveMode.status.starting': 'Iniciando...',
    'liveMode.status.listening': 'Escuchando',
    'liveMode.status.thinking': 'Pensando',
    'liveMode.status.ready': 'Listo',
    'liveMode.errors.cameraDenied': 'Acceso a la cámara denegado',
    'liveMode.errors.screenDenied': 'Compartir pantalla denegado',
    'liveMode.errors.connection': 'Error de conexión',
    'liveMode.controls.close': 'Cerrar modo en vivo',
    'liveMode.controls.mic.mute': 'Silenciar micrófono',
    'liveMode.controls.mic.unmute': 'Activar micrófono',
    'liveMode.controls.camera.on': 'Encender cámara',
    'liveMode.controls.camera.off': 'Apagar cámara',
    'liveMode.controls.screen.start': 'Compartir pantalla',
    'liveMode.controls.screen.stop': 'Dejar de compartir',
    'account.title': 'Cuenta',
    'account.alert.invalidImageType': 'Por favor selecciona un archivo de imagen',
    'account.alert.imageTooLarge': 'Selecciona una imagen más pequeña de 5 MB',
    'account.emailFallback': 'No se proporcionó correo',
    'account.memberSince': 'Miembro desde',
    'account.theme': 'Tema',
    'account.themeDefault': 'Predeterminado',
    'account.status': 'Estado',
    'account.statusAdmin': 'Admin',
    'account.statusMember': 'Miembro',
    'account.button.switchToAdmin': 'Cambiar a administrador',
    'account.button.logoutAdmin': 'Cerrar sesión de administrador',
    'account.button.signOut': 'Cerrar sesión',
    'workspace.title': 'Modelos',
    'workspace.searchPlaceholder': 'Buscar modelos...',
    'workspace.button.newModel': 'Nuevo modelo',
    'workspace.model.baseLabel': 'Basado en:',
    'workspace.model.byLabel': 'Por',
    'workspace.actions.edit': 'Editar',
    'workspace.actions.moreOptions': 'Más opciones',
    'workspace.modal.titleEdit': 'Editar modelo',
    'workspace.modal.titleCreate': 'Crear nuevo modelo',
    'workspace.modal.fieldName': 'Nombre del modelo',
    'workspace.modal.fieldDescription': 'Descripción',
    'workspace.modal.fieldAvatar': 'Avatar',
    'workspace.modal.fieldBaseModel': 'Modelo base',
    'workspace.modal.helperBaseModel': 'Selecciona qué modelo IA debe usar este modelo personalizado',
    'workspace.modal.fieldSystemPrompt': 'Prompt del sistema',
    'workspace.modal.placeholderExamples': 'p.ej. Asistente de código, Redactor creativo',
    'workspace.modal.placeholderDescription': 'Describe brevemente en qué se especializa este modelo...',
    'workspace.modal.placeholderSystemPrompt': 'Ingresa el prompt del sistema que define cómo debe comportarse este modelo...',
    'workspace.modal.status.loadingModels': 'Cargando modelos...',
    'workspace.modal.button.delete': 'Eliminar modelo',
    'workspace.modal.button.cancel': 'Cancelar',
    'workspace.modal.button.save': 'Guardar cambios',
    'workspace.modal.button.create': 'Crear modelo',
    'workspace.baseModelFallback': 'Desconocido',
    'media.title': 'Medios',
    'media.placeholder': 'Aquí irá el contenido de la página de Medios.',
    'flowchart.titleSuffix': 'Diagrama de flujo',
    'flowchart.subtitle': 'Crea, arrastra o sube',
    'flowchart.sidebar.nodesLabel': 'Nodos',
    'flowchart.sidebar.helper': 'Arrastra al lienzo o haz doble clic en una ficha para soltarla en el centro.',
    'flowchart.sidebar.dragOrDouble': 'Arrastra al lienzo o haz doble clic para añadir al centro',
    'flowchart.node.start': 'Inicio',
    'flowchart.node.process': 'Proceso',
    'flowchart.node.decision': 'Decisión',
    'flowchart.node.end': 'Fin',
    'flowchart.toolbar.save': 'Guardar e insertar',
    'flowchart.toolbar.clear': 'Borrar',
    'flowchart.toolbar.upload': 'Subir',
    'flowchart.toolbar.layout': 'Auto-disposición',
    'flowchart.empty.title': 'Crea un diagrama',
    'flowchart.empty.description': 'Arrastra nodos desde la izquierda o haz clic en Subir para traer tu propia imagen o JSON. Conecta nodos arrastrando entre los manejadores. Doble clic para renombrar.',
    'flowchart.error.exportFailed': 'Falló la exportación.',
    'flowchart.error.empty': 'Añade al menos un nodo antes de guardar.',
    'flowchart.error.invalidJson': 'No se pudo leer el archivo JSON.',
    'flowchart.error.unsupportedType': 'Tipo de archivo no admitido. Usa una imagen o JSON.',
    'flowchart.error.aiParseFailed': 'No se pudieron leer las instrucciones generadas por la IA.',
    'graph.titleSuffix': 'Gráfico',
    'graph.placeholder': 'Introduce una expresión...',
    'graph.button.addExpression': '+ Añadir expresión',
    'graph.controls.reset': 'Restablecer vista',
    'graph.controls.zoomIn': 'Acercar',
    'graph.controls.zoomOut': 'Alejar',
    'sandbox3d.title': 'SCULPTOR 3D',
    'sandbox3d.outliner.title': 'ESQUEMA ({{count}})',
    'sandbox3d.gizmoHint': 'Usa el ratón para orbitar • Haz clic para seleccionar • Arrastra el gizmo para mover',
    'sandbox3d.toolbar.addBox': '+ Caja',
    'sandbox3d.toolbar.addSphere': '+ Esfera',
    'sandbox3d.toolbar.addCylinder': '+ Cilindro',
    'sandbox3d.toolbar.addTorus': '+ Toro',
    'sandbox3d.toolbar.delete': 'Eliminar',
    'sandbox3d.toolbar.save': 'Guardar',
    'sandbox3d.section.properties': 'PROPIEDADES',
    'sandbox3d.section.transform': 'TRANSFORMACIÓN',
    'sandbox3d.section.material': 'MATERIAL',
    'sandbox3d.label.position': 'Posición',
    'sandbox3d.label.rotation': 'Rotación',
    'sandbox3d.label.scale': 'Escala',
    'sandbox3d.label.color': 'Color',
    'sandbox3d.label.hex': 'Hex',
    'sandbox3d.noObjectSelected': 'Ningún objeto seleccionado',
    'sandbox3d.types.box': 'caja',
    'sandbox3d.types.sphere': 'esfera',
    'sandbox3d.types.cylinder': 'cilindro',
    'sandbox3d.types.torus': 'toro',
    'equation.title': 'Editor de ecuaciones',
    'equation.preview.hint': 'Escribe matemáticas de forma natural... (p.ej. "1/2", "sqrt(x)", "alpha")',
    'equation.input.placeholder': 'Escribe matemáticas aquí... p.ej. "x^2 + y^2 = r^2" o "1/2"',
    'equation.preview.typing': 'Escribiendo: "{{input}}" → Se renderiza en LaTeX',
    'equation.button.cancel': 'Cancelar',
    'equation.button.insert': 'Insertar ecuación',
    'whiteboard.tool.pencil': 'Lápiz',
    'whiteboard.tool.square': 'Cuadrado',
    'whiteboard.tool.circle': 'Círculo',
    'whiteboard.tool.line': 'Línea',
    'whiteboard.tool.text': 'Texto',
    'whiteboard.tool.eraser': 'Borrador',
    'whiteboard.tool.undo': 'Deshacer',
    'whiteboard.tool.redo': 'Rehacer',
    'whiteboard.tool.clear': 'Borrar',
    'whiteboard.action.export': 'Exportar',
    'whiteboard.action.send': 'Enviar',
    'imageSelector.label': 'Imagen:',
    'imageSelector.placeholder': 'Selecciona un modelo',
    'settings.title': 'Configuración',
    'settings.close': 'Cerrar',
    'settings.saveButton': 'Guardar cambios',
    'settings.nav.general': 'General',
    'settings.nav.appearance': 'Apariencia',
    'settings.nav.interface': 'Interfaz',
    'settings.nav.chats': 'Chats',
    'settings.nav.accessibility': 'Accesibilidad',
    'settings.nav.developer': 'Desarrollador',
    'settings.nav.about': 'Acerca de',
    'settings.sections.general': 'General',
    'settings.sections.appearance': 'Apariencia',
    'settings.sections.interface': 'Interfaz',
    'settings.sections.chats': 'Ajustes de chat',
    'settings.sections.accessibility': 'Accesibilidad',
    'settings.sections.developer': 'Desarrollador',
    'settings.sections.about': 'Acerca de',
    'settings.general.theme.label': 'Tema',
    'settings.general.language.label': 'Idioma',
    'settings.general.notifications.label': 'Notificaciones',
    'settings.themeOptions.light': 'Claro',
    'settings.themeOptions.dark': 'Oscuro',
    'settings.themeOptions.oled': 'OLED',
    'settings.themeOptions.ocean': 'Océano',
    'settings.themeOptions.forest': 'Bosque',
    'settings.themeOptions.sunset': 'Atardecer',
    'settings.themeOptions.sunrise': 'Amanecer',
    'settings.themeOptions.pride': 'Pride',
    'settings.themeOptions.trans': 'Trans',
    'settings.themeOptions.bisexual': 'Bisexual',
    'settings.themeOptions.lakeside': 'Orilla del lago',
    'settings.themeOptions.retro': 'Retro',
    'settings.themeOptions.custom': 'Personalizado',
    'settings.languageOptions.en-US': 'English (US)',
    'settings.languageOptions.fr': 'Français',
    'settings.languageOptions.es': 'Español',
    'settings.languageOptions.de': 'Deutsch',
    'settings.languageOptions.zh': '中文',
    'settings.appearance.fontSize.label': 'Tamaño de fuente',
    'settings.fontSize.small': 'Pequeño',
    'settings.fontSize.medium': 'Medio',
    'settings.fontSize.large': 'Grande',
    'settings.appearance.fontFamily.label': 'Tipografía',
    'settings.fontFamily.system': 'Predeterminada',
    'settings.fontFamily.inter': 'Space Mono',
    'settings.fontFamily.roboto': 'Roboto',
    'settings.fontFamily.opensans': 'Open Sans',
    'settings.fontFamily.montserrat': 'Montserrat',
    'settings.fontFamily.lato': 'Lato',
    'settings.fontFamily.caveat': 'Caveat',
    'settings.fontFamily.georgia': 'Georgia',
    'settings.fontFamily.merriweather': 'Merriweather',
    'settings.appearance.sidebarStyle.label': 'Estilo de la barra lateral',
    'settings.appearance.sidebarStyle.floating': 'Flotante',
    'settings.appearance.sidebarStyle.traditional': 'Tradicional',
    'settings.appearance.sidebarStyle.description': 'Elige entre una barra flotante con bordes redondeados o una barra clásica pegada al borde.',
    'settings.appearance.accent.color': 'Color de acento',
    'settings.appearance.accent.description': 'Los colores de acento actualizan botones, burbujas, interruptores y otros elementos destacados de la interfaz.',
    'settings.chats.profiles.toggleVisibility.label': 'Alternar visibilidad del icono de perfil',
    'settings.chats.profiles.toggleVisibility.description': 'Mostrar el icono de perfil en los chats',
    'settings.chats.features.label': 'Funciones de los mensajes',
    'settings.chats.features.timestamps': 'Mostrar marcas de tiempo',
    'settings.chats.features.modelIcons': 'Mostrar íconos de modelo',
    'settings.chats.features.codeHighlighting': 'Activar resaltado de código',
    'settings.chats.sending.label': 'Envío de mensajes',
    'settings.chats.sending.sendWithEnter': 'Enviar con Enter (Shift+Enter para nueva línea)',
    'settings.chats.alignment.label': 'Alineación de mensajes',
    'settings.chats.alignment.left': 'Izquierda',
    'settings.chats.alignment.right': 'Derecha',
    'settings.interface.layout.label': 'Diseño',
    'settings.interface.layout.autoCollapse': 'Contraer automáticamente la barra lateral mientras escribes',
    'settings.interface.layout.focusMode': 'Modo concentración (oculta la interfaz al escribir)',
    'settings.interface.layout.showGreeting': 'Mostrar mensaje de bienvenida en el chat vacío',
    'settings.interface.bubbles.label': 'Burbujas de mensaje',
    'settings.interface.bubbles.modern': 'Moderno (redondeado)',
    'settings.interface.bubbles.classic': 'Clásico (rectangular)',
    'settings.interface.bubbles.minimal': 'Minimalista (sin burbujas)',
    'settings.interface.spacing.label': 'Espaciado de mensajes',
    'settings.interface.spacing.compact': 'Compacto',
    'settings.interface.spacing.comfortable': 'Cómodo',
    'settings.interface.spacing.spacious': 'Amplio',
    'settings.accessibility.visual.label': 'Comodidad visual',
    'settings.accessibility.visual.highContrast': 'Modo de alto contraste',
    'settings.accessibility.visual.reducedMotion': 'Reducir animaciones y movimiento',
    'settings.accessibility.textSpacing.label': 'Espaciado del texto',
    'settings.accessibility.textSpacing.normal': 'Normal',
    'settings.accessibility.textSpacing.relaxed': 'Relajado',
    'settings.accessibility.textSpacing.loose': 'Amplio',
    'settings.developer.onboarding.label': 'Introducción',
    'settings.developer.onboarding.description': 'Restablece el flujo de bienvenida para volver a ver el tutorial.',
    'settings.developer.onboarding.restart': 'Reiniciar la introducción',
    'settings.about.logoAlt.default': 'Logotipo de Sculptor',
    'settings.about.logoAlt.lakeside': 'Logotipo de Andromeda',
    'settings.about.logoTitle.default': 'Sculptor',
    'settings.about.logoTitle.lakeside': 'Andromeda',
    'settings.about.madeWith': 'Creado con',
    'settings.about.prideWord': 'Orgullo',
    'settings.about.teamMessage': 'Del equipo Andromeda, con ❤️',
    'settings.about.version': 'Sculptor Alpha 0.0.6',
    'settings.mobile.chatBehavior': 'Comportamiento del chat',
    'settings.mobile.themeDescription': 'Elige tu esquema de color preferido',
    'settings.mobile.fontSizeDescription': 'Ajusta el tamaño del texto para mejorar la lectura',
    'settings.mobile.messageStyle.label': 'Estilo de los mensajes',
    'settings.mobile.messageStyle.description': 'Elige cómo se ven las burbujas del chat',
    'settings.mobile.sendWithEnter.title': 'Enviar con Enter',
    'settings.mobile.sendWithEnter.description': 'Pulsa Enter para enviar mensajes',
    'settings.mobile.timestamps.title': 'Mostrar marcas de tiempo',
    'settings.mobile.timestamps.description': 'Muestra la hora debajo de cada mensaje',
    'settings.mobile.modelIcons.title': 'Mostrar íconos de modelo',
    'settings.mobile.modelIcons.description': 'Muestra el avatar del modelo IA junto a las respuestas',
    'settings.mobile.greeting.title': 'Mostrar saludo',
    'settings.mobile.greeting.description': 'Muestra un mensaje de bienvenida en chats vacíos',
    'settings.mobile.codeHighlighting.title': 'Resaltado de código',
    'settings.mobile.codeHighlighting.description': 'Aplica resaltado de sintaxis a los bloques de código',
    'settings.mobile.accessibility.highContrastDescription': 'Aumenta el contraste para mejorar la visibilidad',
    'settings.mobile.accessibility.reducedMotionDescription': 'Reduce las animaciones y transiciones'
  },
  de: {
    'sidebar.newChat': 'Neuer Chat',
    'sidebar.searchPlaceholder': 'Chats durchsuchen...',
    'sidebar.nav.chat': 'Chat',
    'sidebar.nav.media': 'Medien',
    'sidebar.nav.news': 'Nachrichten',
    'sidebar.nav.projects': 'Projekte',
    'sidebar.nav.workspace': 'Arbeitsbereich',
    'sidebar.nav.admin': 'Admin',
    'sidebar.section.chats': 'Chats',
    'sidebar.emptySearch': 'Keine Chats zu "{{term}}" gefunden',
    'sidebar.button.share': 'Chat teilen',
    'sidebar.button.delete': 'Chat löschen',
    'sidebar.profile.signIn': 'Anmelden',
    'sidebar.profile.viewProfile': 'Profil anzeigen: {{username}}',
    'sidebar.profile.settings': 'Einstellungen',
    'sidebar.profile.info': 'Info',
    'sidebar.profile.signOut': 'Abmelden',
    'sidebar.collapseTitle': 'Seitenleiste einklappen',
    'sidebar.copySuccess': 'Freigabelink in die Zwischenablage kopiert!',
    'sidebar.copyFailure': 'Freigabelink konnte nicht kopiert werden.',
    'sidebar.mobile.expand': 'Menü öffnen',
    'sidebar.mobile.collapse': 'Menü schließen',
    'chat.defaultTitle': 'Neuer Chat',
    'chat.newConversation': 'Neue Unterhaltung',
    'chat.emptyHeading': 'Kein Chat verfügbar',
    'chat.emptySubheading': 'Neuer Chat wird erstellt...',
    'chat.emptyRefresh': 'Seite aktualisieren',
    'composer.placeholder.image': 'Eingabeaufforderung für die Bildgenerierung...',
    'composer.placeholder.video': 'Eingabeaufforderung für die Videogenerierung...',
    'composer.placeholder.flowchart': 'Beschreibe das gewünschte Flussdiagramm...',
    'composer.placeholder.waiting': 'Warte auf Antwort...',
    'composer.placeholder.processing': 'Datei wird verarbeitet...',
    'composer.placeholder.attachedSingle': 'Angehängt: {{name}}. Text hinzufügen oder senden.',
    'composer.placeholder.attachedMultiple': 'Angehängt: {{count}} Dateien. Text hinzufügen oder senden.',
    'composer.placeholder.default': 'Nachricht eingeben, Bild einfügen oder Datei anhängen...',
    'composer.liveModeActive': 'Live-Modus aktiv',
    'composer.liveModeStart': 'Live-Modus starten',
    'composer.chip.thinking': 'Denken',
    'composer.chip.search': 'Suchen',
    'composer.chip.deepResearch': 'Tiefenrecherche',
    'composer.chip.analysis': 'Analyse',
    'composer.chip.create': 'Erstellen',
    'composer.chip.createImage': 'Bild erstellen',
    'composer.chip.createVideo': 'Video erstellen',
    'composer.chip.createFlowchart': 'Flussdiagramm erstellen',
    'composer.analysis.tooltip': 'Codeausführung – Daten analysieren, Diagramme erstellen und mehr',
    'composer.toolbar.open': 'Werkzeugleiste öffnen',
    'composer.toolbar.close': 'Werkzeugleiste schließen',
    'composer.toolbar.moreActions': 'Weitere Aktionen',
    'composer.toolbar.equationEditor': 'Formeleditor',
    'composer.toolbar.whiteboard': 'Whiteboard',
    'composer.toolbar.graphing': 'Grafikrechner',
    'composer.toolbar.flowchart': 'Flussdiagramm',
    'composer.toolbar.sandbox3d': '3D-Sandbox',
    'composer.menu.modeTitle': 'Modus wählen',
    'composer.menu.createTitle': 'Inhalt erstellen',
    'composer.menu.default': 'Standard',
    'composer.menu.instant': 'Sofort',
    'composer.menu.image': 'Bild',
    'composer.menu.video': 'Video',
    'composer.menu.flowchart': 'Flussdiagramm',
    'composer.menu.sandbox3d': '3D-Sandbox',
    'news.title': 'Nachrichten',
    'news.refresh': 'Aktualisieren',
    'news.refreshing': 'Aktualisiere...',
    'news.filters.top': 'Top-Themen',
    'news.filters.saved': 'Gespeichert',
    'news.filters.tech': 'Technologie',
    'news.filters.sports': 'Sport',
    'news.filters.finance': 'Finanzen',
    'news.filters.art': 'Kunst & Kultur',
    'news.filters.tv': 'TV & Unterhaltung',
    'news.filters.politics': 'Politik',
    'news.loadingList': 'Neueste Artikel werden geladen...',
    'news.error.title': 'Nachrichten konnten nicht geladen werden',
    'news.error.retry': 'Erneut versuchen',
    'news.error.fetch': 'Die ausgewählte Nachrichtenkategorie konnte nicht geladen werden.',
    'news.error.articleContent': 'Der vollständige Artikel konnte nicht geladen werden. Zeige stattdessen eine Vorschau.',
    'news.empty.saved': 'Du hast noch keine Artikel gespeichert.',
    'news.empty.category': 'In dieser Kategorie gibt es noch keine Artikel. Schau bald wieder vorbei.',
    'news.article.noContent': 'Für diesen Artikel ist kein Inhalt verfügbar.',
    'news.article.loading': 'Artikel wird geladen...',
    'news.summary.couldNotGenerate': 'Für diesen Artikel konnte kein Zusammenfassung erstellt werden.',
    'news.summary.failed': 'Wir konnten diesen Artikel nicht zusammenfassen. Bitte später erneut versuchen.',
    'news.loadingArticle': 'Vollständiger Artikel wird geladen...',
    'news.generatingSummary': 'KI-Zusammenfassung wird erstellt...',
    'news.fullArticleTag': 'Vollständiger Artikel',
    'news.readOriginal': 'Originalartikel auf {{source}} lesen →',
    'news.detail.byAuthor': 'Von {{author}}',
    'news.detail.source': 'Quelle: {{source}}',
    'news.detail.published': 'Veröffentlicht {{time}}',
    'news.category.uncategorized': 'Ohne Kategorie',
    'projects.title': 'Projekte',
    'projects.createButton': 'Neues Projekt',
    'projects.searchPlaceholder': 'Projekte durchsuchen...',
    'projects.emptyTitle': 'Starte dein erstes Projekt',
    'projects.emptyDescription': 'Organisiere Ideen, Dateien und Prompts in eigenen Projektbereichen.',
    'models.noModels': 'Keine Modelle verfügbar',
    'models.searchPlaceholder': 'Modelle durchsuchen...',
    'models.provider.google': 'Google AI',
    'models.provider.openrouter': 'OpenRouter',
    'models.provider.backend': 'Backend',
    'models.provider.local': 'Lokal',
    'models.provider.anthropic': 'Anthropic',
    'models.provider.openai': 'OpenAI',
    'models.provider.nvidia': 'NVIDIA',
    'models.provider.generic': 'KI',
    'models.selectPlaceholder': 'Modell auswählen',
    'models.sectionHeader': 'Wähle ein Modell',
    'chat.history.noMessages': 'Noch keine Nachrichten',
    'chat.history.noContent': 'Kein Inhalt',
    'chat.attachments.uploaded': 'Hochgeladener Inhalt',
    'chat.list.untitled': 'Chat {{id}}',
    'chat.status.thinking': 'Denkt...',
    'chat.labels.request': 'Anfrage',
    'chat.labels.query': 'Abfrage',
    'chat.labels.prompt': 'Prompt',
    'chat.labels.error': 'Fehler',
    'chat.labels.parameters': 'Parameter',
    'chat.labels.result': 'Ergebnis',
    'chat.labels.yourRequest': 'deine Anfrage',
    'chat.labels.yourQuery': 'deine Abfrage',
    'chat.labels.yourPrompt': 'dein Prompt',
    'chat.errors.apiKeys.notConfigured': 'API-Schlüssel sind nicht konfiguriert.',
    'chat.errors.apiKeys.instructions': 'Füge OPENROUTER_API_KEY, GEMINI_API_KEY, ANTHROPIC_API_KEY oder OPENAI_API_KEY in .dev.vars hinzu, um Live-Antworten zu aktivieren.',
    'chat.errors.generic': 'Antwort konnte nicht erzeugt werden. Bitte versuche es noch einmal.',
    'chat.flowchart.creating': 'Erstelle Flussdiagramm für: "{{prompt}}"...',
    'chat.flowchart.openBuilder': 'Flussdiagramm-Editor öffnen',
    'chat.flowchart.instructionsHint': 'Flussdiagramm-Anweisungen erstellt. Klicke auf "{{buttonLabel}}" zum Anzeigen und Bearbeiten.',
    'chat.flowchart.failed': 'Flussdiagramm konnte nicht erstellt werden',
    'chat.research.performing': 'Tiefenanalyse läuft...',
    'chat.research.initializing': 'Initialisiere...',
    'chat.research.results': 'Ergebnisse der Tiefenrecherche',
    'chat.research.questionsLabel': 'Forschungsfragen ({{count}}):',
    'chat.research.analyzedBy': 'Analysiert von {{count}} Forschungsagenten',
    'chat.research.failed': 'Tiefenrecherche fehlgeschlagen',
    'chat.image.generating': 'Generiere Bild für: "{{prompt}}"...',
    'chat.image.failed': 'Bildgenerierung fehlgeschlagen',
    'chat.video.generating': 'Generiere Video für: "{{prompt}}"...',
    'chat.video.failed': 'Videogenerierung fehlgeschlagen',
    'chat.actions.copyInstructions': 'Anweisungen kopieren',
    'chat.actions.copyResults': 'Ergebnisse kopieren',
    'chat.actions.copyUrl': 'URL kopieren',
    'chat.actions.readAloud': 'Vorlesen',
    'chat.actions.stopSpeaking': 'Vorlesen stoppen',
    'chat.actions.load3d': 'In 3D laden',
    'chat.share.title': 'KI-Chatnachricht',
    'chat.thinking.header.thoughtsAndTools': 'Gedanken & Tools',
    'chat.thinking.header.thoughts': 'Gedanken',
    'chat.thinking.header.tools': 'Tool-Aktivität',
    'chat.thinking.toolActivity': '🛠️ Tool-Aktivität',
    'chat.thinking.section.reasoning': '💭 Überlegung',
    'chat.thinking.tool.parameters': 'Parameter:',
    'chat.thinking.tool.result': 'Ergebnis:',
    'chat.thinking.tool.error': 'Fehler:',
    'chat.thinking.tool.unknown': 'Unbekanntes Tool',
    'chat.thinking.tool.status.pending': 'Ausstehend',
    'chat.thinking.tool.status.executing': 'Läuft',
    'chat.thinking.tool.status.completed': 'Abgeschlossen',
    'chat.thinking.tool.status.error': 'Fehler',
    'liveMode.status.connecting': 'Verbindung wird hergestellt...',
    'liveMode.status.starting': 'Startet...',
    'liveMode.status.listening': 'Hört zu',
    'liveMode.status.thinking': 'Denkt nach',
    'liveMode.status.ready': 'Bereit',
    'liveMode.errors.cameraDenied': 'Kamerazugriff verweigert',
    'liveMode.errors.screenDenied': 'Bildschirmfreigabe verweigert',
    'liveMode.errors.connection': 'Verbindungsfehler',
    'liveMode.controls.close': 'Live-Modus schließen',
    'liveMode.controls.mic.mute': 'Mikrofon stummschalten',
    'liveMode.controls.mic.unmute': 'Mikrofon aktivieren',
    'liveMode.controls.camera.on': 'Kamera einschalten',
    'liveMode.controls.camera.off': 'Kamera ausschalten',
    'liveMode.controls.screen.start': 'Bildschirm teilen',
    'liveMode.controls.screen.stop': 'Freigabe beenden',
    'account.title': 'Konto',
    'account.alert.invalidImageType': 'Bitte wähle eine Bilddatei aus',
    'account.alert.imageTooLarge': 'Bitte wähle ein Bild kleiner als 5 MB',
    'account.emailFallback': 'Keine E-Mail angegeben',
    'account.memberSince': 'Mitglied seit',
    'account.theme': 'Thema',
    'account.themeDefault': 'Standard',
    'account.status': 'Status',
    'account.statusAdmin': 'Admin',
    'account.statusMember': 'Mitglied',
    'account.button.switchToAdmin': 'Zum Admin wechseln',
    'account.button.logoutAdmin': 'Admin abmelden',
    'account.button.signOut': 'Abmelden',
    'workspace.title': 'Modelle',
    'workspace.searchPlaceholder': 'Modelle durchsuchen...',
    'workspace.button.newModel': 'Neues Modell',
    'workspace.model.baseLabel': 'Basierend auf:',
    'workspace.model.byLabel': 'Von',
    'workspace.actions.edit': 'Bearbeiten',
    'workspace.actions.moreOptions': 'Weitere Optionen',
    'workspace.modal.titleEdit': 'Modell bearbeiten',
    'workspace.modal.titleCreate': 'Neues Modell erstellen',
    'workspace.modal.fieldName': 'Modellname',
    'workspace.modal.fieldDescription': 'Beschreibung',
    'workspace.modal.fieldAvatar': 'Avatar',
    'workspace.modal.fieldBaseModel': 'Basis-Modell',
    'workspace.modal.helperBaseModel': 'Wähle, welches KI-Modell dieses benutzerdefinierte Modell nutzen soll',
    'workspace.modal.fieldSystemPrompt': 'System-Prompt',
    'workspace.modal.placeholderExamples': 'z. B. Code-Assistent, Kreativautor',
    'workspace.modal.placeholderDescription': 'Beschreibe kurz, worin dieses Modell spezialisiert ist...',
    'workspace.modal.placeholderSystemPrompt': 'Gib den System-Prompt ein, der das Verhalten dieses Modells definiert...',
    'workspace.modal.status.loadingModels': 'Modelle werden geladen...',
    'workspace.modal.button.delete': 'Modell löschen',
    'workspace.modal.button.cancel': 'Abbrechen',
    'workspace.modal.button.save': 'Änderungen speichern',
    'workspace.modal.button.create': 'Modell erstellen',
    'workspace.baseModelFallback': 'Unbekannt',
    'media.title': 'Medien',
    'media.placeholder': 'Inhalt für die Medienseite folgt hier.',
    'flowchart.titleSuffix': 'Flussdiagramm',
    'flowchart.subtitle': 'Erstellen, ziehen oder hochladen',
    'flowchart.sidebar.nodesLabel': 'Knoten',
    'flowchart.sidebar.helper': 'Auf die Leinwand ziehen oder Chip doppelklicken, um ihn in der Mitte abzulegen.',
    'flowchart.sidebar.dragOrDouble': 'Auf die Leinwand ziehen oder doppelklicken, um in der Mitte hinzuzufügen',
    'flowchart.node.start': 'Start',
    'flowchart.node.process': 'Prozess',
    'flowchart.node.decision': 'Entscheidung',
    'flowchart.node.end': 'Ende',
    'flowchart.toolbar.save': 'Speichern & einfügen',
    'flowchart.toolbar.clear': 'Zurücksetzen',
    'flowchart.toolbar.upload': 'Hochladen',
    'flowchart.toolbar.layout': 'Auto-Layout',
    'flowchart.empty.title': 'Flussdiagramm erstellen',
    'flowchart.empty.description': 'Ziehe Knoten aus der Seitenleiste oder klicke auf Hochladen, um ein eigenes Bild oder JSON einzufügen. Verbinde Knoten durch Ziehen zwischen den Anschlüssen. Doppelklick zum Umbenennen.',
    'flowchart.error.exportFailed': 'Export fehlgeschlagen.',
    'flowchart.error.empty': 'Füge mindestens einen Knoten hinzu, bevor du speicherst.',
    'flowchart.error.invalidJson': 'JSON-Datei konnte nicht gelesen werden.',
    'flowchart.error.unsupportedType': 'Nicht unterstützter Dateityp. Verwende ein Bild oder JSON.',
    'flowchart.error.aiParseFailed': 'KI-generierte Anweisungen konnten nicht gelesen werden.',
    'graph.titleSuffix': 'Diagramm',
    'graph.placeholder': 'Gib einen Ausdruck ein...',
    'graph.button.addExpression': '+ Ausdruck hinzufügen',
    'graph.controls.reset': 'Ansicht zurücksetzen',
    'graph.controls.zoomIn': 'Reinzoomen',
    'graph.controls.zoomOut': 'Rauszoomen',
    'sandbox3d.title': 'SCULPTOR 3D',
    'sandbox3d.outliner.title': 'OUTLINER ({{count}})',
    'sandbox3d.gizmoHint': 'Maus zum Orbitieren nutzen • Klicken zum Auswählen • Gizmo ziehen zum Verschieben',
    'sandbox3d.toolbar.addBox': '+ Box',
    'sandbox3d.toolbar.addSphere': '+ Kugel',
    'sandbox3d.toolbar.addCylinder': '+ Zyl',
    'sandbox3d.toolbar.addTorus': '+ Torus',
    'sandbox3d.toolbar.delete': 'Löschen',
    'sandbox3d.toolbar.save': 'Speichern',
    'sandbox3d.section.properties': 'EIGENSCHAFTEN',
    'sandbox3d.section.transform': 'TRANSFORMATION',
    'sandbox3d.section.material': 'MATERIAL',
    'sandbox3d.label.position': 'Position',
    'sandbox3d.label.rotation': 'Rotation',
    'sandbox3d.label.scale': 'Skalierung',
    'sandbox3d.label.color': 'Farbe',
    'sandbox3d.label.hex': 'Hex',
    'sandbox3d.noObjectSelected': 'Kein Objekt ausgewählt',
    'sandbox3d.types.box': 'Box',
    'sandbox3d.types.sphere': 'Kugel',
    'sandbox3d.types.cylinder': 'Zylinder',
    'sandbox3d.types.torus': 'Torus',
    'equation.title': 'Gleichungseditor',
    'equation.preview.hint': 'Tippe Mathematik natürlich ein... (z. B. "1/2", "sqrt(x)", "alpha")',
    'equation.input.placeholder': 'Tippe Mathematik hier ein... z. B. "x^2 + y^2 = r^2" oder "1/2"',
    'equation.preview.typing': 'Tippe: "{{input}}" → Wird als LaTeX dargestellt',
    'equation.button.cancel': 'Abbrechen',
    'equation.button.insert': 'Gleichung einfügen',
    'whiteboard.tool.pencil': 'Stift',
    'whiteboard.tool.square': 'Quadrat',
    'whiteboard.tool.circle': 'Kreis',
    'whiteboard.tool.line': 'Linie',
    'whiteboard.tool.text': 'Text',
    'whiteboard.tool.eraser': 'Radierer',
    'whiteboard.tool.undo': 'Rückgängig',
    'whiteboard.tool.redo': 'Wiederholen',
    'whiteboard.tool.clear': 'Löschen',
    'whiteboard.action.export': 'Exportieren',
    'whiteboard.action.send': 'Senden',
    'imageSelector.label': 'Bild:',
    'imageSelector.placeholder': 'Modell auswählen',
    'settings.title': 'Einstellungen',
    'settings.close': 'Schließen',
    'settings.saveButton': 'Änderungen speichern',
    'settings.nav.general': 'Allgemein',
    'settings.nav.appearance': 'Darstellung',
    'settings.nav.interface': 'Interface',
    'settings.nav.chats': 'Chats',
    'settings.nav.accessibility': 'Barrierefreiheit',
    'settings.nav.developer': 'Entwickler',
    'settings.nav.about': 'Info',
    'settings.sections.general': 'Allgemein',
    'settings.sections.appearance': 'Darstellung',
    'settings.sections.interface': 'Interface',
    'settings.sections.chats': 'Chat-Einstellungen',
    'settings.sections.accessibility': 'Barrierefreiheit',
    'settings.sections.developer': 'Entwickler',
    'settings.sections.about': 'Info',
    'settings.general.theme.label': 'Design',
    'settings.general.language.label': 'Sprache',
    'settings.general.notifications.label': 'Benachrichtigungen',
    'settings.themeOptions.light': 'Hell',
    'settings.themeOptions.dark': 'Dunkel',
    'settings.themeOptions.oled': 'OLED',
    'settings.themeOptions.ocean': 'Ozean',
    'settings.themeOptions.forest': 'Wald',
    'settings.themeOptions.sunset': 'Sonnenuntergang',
    'settings.themeOptions.sunrise': 'Sonnenaufgang',
    'settings.themeOptions.pride': 'Pride',
    'settings.themeOptions.trans': 'Trans',
    'settings.themeOptions.bisexual': 'Bisexuell',
    'settings.themeOptions.lakeside': 'Seeufer',
    'settings.themeOptions.retro': 'Retro',
    'settings.themeOptions.custom': 'Benutzerdefiniert',
    'settings.languageOptions.en-US': 'English (US)',
    'settings.languageOptions.fr': 'Français',
    'settings.languageOptions.es': 'Español',
    'settings.languageOptions.de': 'Deutsch',
    'settings.languageOptions.zh': '中文',
    'settings.appearance.fontSize.label': 'Schriftgröße',
    'settings.fontSize.small': 'Klein',
    'settings.fontSize.medium': 'Mittel',
    'settings.fontSize.large': 'Groß',
    'settings.appearance.fontFamily.label': 'Schriftart',
    'settings.fontFamily.system': 'Systemstandard',
    'settings.fontFamily.inter': 'Space Mono',
    'settings.fontFamily.roboto': 'Roboto',
    'settings.fontFamily.opensans': 'Open Sans',
    'settings.fontFamily.montserrat': 'Montserrat',
    'settings.fontFamily.lato': 'Lato',
    'settings.fontFamily.caveat': 'Caveat',
    'settings.fontFamily.georgia': 'Georgia',
    'settings.fontFamily.merriweather': 'Merriweather',
    'settings.appearance.sidebarStyle.label': 'Stil der Seitenleiste',
    'settings.appearance.sidebarStyle.floating': 'Schwebend',
    'settings.appearance.sidebarStyle.traditional': 'Klassisch',
    'settings.appearance.sidebarStyle.description': 'Wähle zwischen einer schwebenden Seitenleiste mit abgerundeten Ecken oder einer klassischen Leiste am Bildschirmrand.',
    'settings.appearance.accent.color': 'Akzentfarbe',
    'settings.appearance.accent.description': 'Akzentfarben aktualisieren Buttons, Blasen, Schalter und andere Hervorhebungen in der Oberfläche.',
    'settings.chats.profiles.toggleVisibility.label': 'Sichtbarkeit des Profilbildes umschalten',
    'settings.chats.profiles.toggleVisibility.description': 'Profilbild in Chats anzeigen',
    'settings.chats.features.label': 'Nachrichtenfunktionen',
    'settings.chats.features.timestamps': 'Zeitstempel anzeigen',
    'settings.chats.features.modelIcons': 'Modell-Icons anzeigen',
    'settings.chats.features.codeHighlighting': 'Code-Syntax hervorheben',
    'settings.chats.sending.label': 'Nachrichten senden',
    'settings.chats.sending.sendWithEnter': 'Mit Enter senden (Shift+Enter für neue Zeile)',
    'settings.chats.alignment.label': 'Ausrichtung der Nachrichten',
    'settings.chats.alignment.left': 'Links',
    'settings.chats.alignment.right': 'Rechts',
    'settings.interface.layout.label': 'Layout',
    'settings.interface.layout.autoCollapse': 'Seitenleiste beim Schreiben automatisch ausblenden',
    'settings.interface.layout.focusMode': 'Fokusmodus (UI beim Tippen ausblenden)',
    'settings.interface.layout.showGreeting': 'Begrüßung im leeren Chat anzeigen',
    'settings.interface.bubbles.label': 'Nachrichtenblasen',
    'settings.interface.bubbles.modern': 'Modern (abgerundet)',
    'settings.interface.bubbles.classic': 'Klassisch (rechteckig)',
    'settings.interface.bubbles.minimal': 'Minimal (ohne Blasen)',
    'settings.interface.spacing.label': 'Nachrichtenabstand',
    'settings.interface.spacing.compact': 'Kompakt',
    'settings.interface.spacing.comfortable': 'Angenehm',
    'settings.interface.spacing.spacious': 'Weit',
    'settings.accessibility.visual.label': 'Visueller Komfort',
    'settings.accessibility.visual.highContrast': 'Modus mit hohem Kontrast',
    'settings.accessibility.visual.reducedMotion': 'Animationen und Bewegungen reduzieren',
    'settings.accessibility.textSpacing.label': 'Zeilenabstand',
    'settings.accessibility.textSpacing.normal': 'Normal',
    'settings.accessibility.textSpacing.relaxed': 'Locker',
    'settings.accessibility.textSpacing.loose': 'Weit',
    'settings.developer.onboarding.label': 'Onboarding',
    'settings.developer.onboarding.description': 'Setzt den Willkommensablauf zurück, um das Tutorial erneut zu sehen.',
    'settings.developer.onboarding.restart': 'Onboarding neu starten',
    'settings.about.logoAlt.default': 'Sculptor-Logo',
    'settings.about.logoAlt.lakeside': 'Andromeda-Logo',
    'settings.about.logoTitle.default': 'Sculptor',
    'settings.about.logoTitle.lakeside': 'Andromeda',
    'settings.about.madeWith': 'Gemacht mit',
    'settings.about.prideWord': 'Pride',
    'settings.about.teamMessage': 'Vom Andromeda-Team, mit ❤️',
    'settings.about.version': 'Sculptor Alpha 0.0.6',
    'settings.mobile.chatBehavior': 'Chat-Verhalten',
    'settings.mobile.themeDescription': 'Wähle dein bevorzugtes Farbschema',
    'settings.mobile.fontSizeDescription': 'Passe die Schriftgröße für bessere Lesbarkeit an',
    'settings.mobile.messageStyle.label': 'Nachrichtenstil',
    'settings.mobile.messageStyle.description': 'Lege fest, wie die Chatblasen aussehen',
    'settings.mobile.sendWithEnter.title': 'Mit Enter senden',
    'settings.mobile.sendWithEnter.description': 'Drücke Enter, um Nachrichten zu senden',
    'settings.mobile.timestamps.title': 'Zeitstempel anzeigen',
    'settings.mobile.timestamps.description': 'Zeigt die Uhrzeit unter jeder Nachricht an',
    'settings.mobile.modelIcons.title': 'Modell-Icons anzeigen',
    'settings.mobile.modelIcons.description': 'Zeigt das KI-Modell neben den Antworten',
    'settings.mobile.greeting.title': 'Begrüßung anzeigen',
    'settings.mobile.greeting.description': 'Zeigt eine Begrüßung in leeren Chats an',
    'settings.mobile.codeHighlighting.title': 'Code-Hervorhebung',
    'settings.mobile.codeHighlighting.description': 'Syntax-Hervorhebung für Codeblöcke',
    'settings.mobile.accessibility.highContrastDescription': 'Erhöht den Kontrast für bessere Lesbarkeit',
    'settings.mobile.accessibility.reducedMotionDescription': 'Reduziert Animationen und Übergänge'
  },
  zh: {
    'sidebar.newChat': '新聊天',
    'sidebar.searchPlaceholder': '搜索聊天...',
    'sidebar.nav.chat': '聊天',
    'sidebar.nav.media': '媒体',
    'sidebar.nav.news': '新闻',
    'sidebar.nav.projects': '项目',
    'sidebar.nav.workspace': '工作区',
    'sidebar.nav.admin': '管理',
    'sidebar.section.chats': '聊天',
    'sidebar.emptySearch': '未找到包含“{{term}}”的聊天',
    'sidebar.button.share': '分享聊天',
    'sidebar.button.delete': '删除聊天',
    'sidebar.profile.signIn': '登录',
    'sidebar.profile.viewProfile': '查看资料：{{username}}',
    'sidebar.profile.settings': '设置',
    'sidebar.profile.info': '信息',
    'sidebar.profile.signOut': '退出登录',
    'sidebar.collapseTitle': '折叠侧边栏',
    'sidebar.copySuccess': '分享链接已复制到剪贴板！',
    'sidebar.copyFailure': '无法复制分享链接。',
    'sidebar.mobile.expand': '展开菜单',
    'sidebar.mobile.collapse': '收起菜单',
    'chat.defaultTitle': '新聊天',
    'chat.newConversation': '新会话',
    'chat.emptyHeading': '暂无聊天',
    'chat.emptySubheading': '正在创建新聊天...',
    'chat.emptyRefresh': '刷新页面',
    'composer.placeholder.image': '输入用于生成图像的提示...',
    'composer.placeholder.video': '输入用于生成视频的提示...',
    'composer.placeholder.flowchart': '描述你想创建的流程图...',
    'composer.placeholder.waiting': '等待回复...',
    'composer.placeholder.processing': '正在处理文件...',
    'composer.placeholder.attachedSingle': '已附加：{{name}}。添加文本或发送。',
    'composer.placeholder.attachedMultiple': '已附加：{{count}} 个文件。添加文本或发送。',
    'composer.placeholder.default': '输入消息、粘贴图像或附加文件...',
    'composer.liveModeActive': '实时模式已开启',
    'composer.liveModeStart': '启动实时模式',
    'composer.chip.thinking': '思考',
    'composer.chip.search': '搜索',
    'composer.chip.deepResearch': '深度研究',
    'composer.chip.analysis': '分析',
    'composer.chip.create': '创作',
    'composer.chip.createImage': '生成图片',
    'composer.chip.createVideo': '生成视频',
    'composer.chip.createFlowchart': '创建流程图',
    'composer.analysis.tooltip': '代码执行——分析数据、生成图表等',
    'composer.toolbar.open': '打开工具栏',
    'composer.toolbar.close': '关闭工具栏',
    'composer.toolbar.moreActions': '更多操作',
    'composer.toolbar.equationEditor': '公式编辑器',
    'composer.toolbar.whiteboard': '白板',
    'composer.toolbar.graphing': '图形计算器',
    'composer.toolbar.flowchart': '流程图',
    'composer.toolbar.sandbox3d': '3D 沙盒',
    'composer.menu.modeTitle': '选择模式',
    'composer.menu.createTitle': '创建内容',
    'composer.menu.default': '默认',
    'composer.menu.instant': '即时',
    'composer.menu.image': '图像',
    'composer.menu.video': '视频',
    'composer.menu.flowchart': '流程图',
    'composer.menu.sandbox3d': '3D 沙盒',
    'news.title': '新闻',
    'news.refresh': '刷新',
    'news.refreshing': '正在刷新...',
    'news.filters.top': '头条',
    'news.filters.saved': '已保存',
    'news.filters.tech': '科技',
    'news.filters.sports': '体育',
    'news.filters.finance': '财经',
    'news.filters.art': '艺术与文化',
    'news.filters.tv': '影视与娱乐',
    'news.filters.politics': '政治',
    'news.loadingList': '正在加载最新文章...',
    'news.error.title': '无法加载新闻',
    'news.error.retry': '重试',
    'news.error.fetch': '无法获取所选的新闻分类。',
    'news.error.articleContent': '无法加载完整文章，已显示摘要。',
    'news.empty.saved': '你尚未保存任何文章。',
    'news.empty.category': '该分类暂时没有文章，请稍后再来。',
    'news.article.noContent': '此文章暂无可用内容。',
    'news.article.loading': '正在加载文章...',
    'news.summary.couldNotGenerate': '无法为此文章生成摘要。',
    'news.summary.failed': '未能总结此文章，请稍后再试。',
    'news.loadingArticle': '正在加载完整文章...',
    'news.generatingSummary': '正在生成 AI 摘要...',
    'news.fullArticleTag': '完整文章',
    'news.readOriginal': '在 {{source}} 阅读原文 →',
    'news.detail.byAuthor': '作者：{{author}}',
    'news.detail.source': '来源：{{source}}',
    'news.detail.published': '发布时间：{{time}}',
    'news.category.uncategorized': '未分类',
    'projects.title': '项目',
    'projects.createButton': '新建项目',
    'projects.searchPlaceholder': '搜索项目...',
    'projects.emptyTitle': '创建你的第一个项目',
    'projects.emptyDescription': '将创意、文件和提示整理在专属项目空间中。',
    'models.noModels': '暂无可用模型',
    'models.searchPlaceholder': '搜索模型...',
    'models.provider.google': 'Google AI',
    'models.provider.openrouter': 'OpenRouter',
    'models.provider.backend': '后端',
    'models.provider.local': '本地',
    'models.provider.anthropic': 'Anthropic',
    'models.provider.openai': 'OpenAI',
    'models.provider.nvidia': 'NVIDIA',
    'models.provider.generic': 'AI',
    'models.selectPlaceholder': '选择模型',
    'models.sectionHeader': '选择一个模型',
    'chat.history.noMessages': '暂无消息',
    'chat.history.noContent': '无内容',
    'chat.attachments.uploaded': '已上传的内容',
    'chat.list.untitled': '聊天 {{id}}',
    'chat.status.thinking': '思考中...',
    'chat.labels.request': '请求',
    'chat.labels.query': '查询',
    'chat.labels.prompt': '提示词',
    'chat.labels.error': '错误',
    'chat.labels.parameters': '参数',
    'chat.labels.result': '结果',
    'chat.labels.yourRequest': '你的请求',
    'chat.labels.yourQuery': '你的查询',
    'chat.labels.yourPrompt': '你的提示词',
    'chat.errors.apiKeys.notConfigured': '尚未配置 API 密钥。',
    'chat.errors.apiKeys.instructions': '请在 .dev.vars 中添加 OPENROUTER_API_KEY、GEMINI_API_KEY、ANTHROPIC_API_KEY 或 OPENAI_API_KEY 以启用实时回复。',
    'chat.errors.generic': '无法生成回复。请重试。',
    'chat.flowchart.creating': '正在为 "{{prompt}}" 创建流程图...',
    'chat.flowchart.openBuilder': '打开流程图构建器',
    'chat.flowchart.instructionsHint': '已生成流程图说明。点击 "{{buttonLabel}}" 以查看和编辑。',
    'chat.flowchart.failed': '流程图生成失败',
    'chat.research.performing': '正在执行深度研究...',
    'chat.research.initializing': '正在初始化...',
    'chat.research.results': '深度研究结果',
    'chat.research.questionsLabel': '研究问题（{{count}}）：',
    'chat.research.analyzedBy': '由 {{count}} 个研究代理进行分析',
    'chat.research.failed': '深度研究失败',
    'chat.image.generating': '正在为 "{{prompt}}" 生成图片...',
    'chat.image.failed': '图片生成失败',
    'chat.video.generating': '正在为 "{{prompt}}" 生成视频...',
    'chat.video.failed': '视频生成失败',
    'chat.actions.copyInstructions': '复制说明',
    'chat.actions.copyResults': '复制结果',
    'chat.actions.copyUrl': '复制链接',
    'chat.actions.readAloud': '朗读',
    'chat.actions.stopSpeaking': '停止朗读',
    'chat.actions.load3d': '在 3D 中加载',
    'chat.share.title': 'AI 对话消息',
    'chat.thinking.header.thoughtsAndTools': '思路与工具',
    'chat.thinking.header.thoughts': '思路',
    'chat.thinking.header.tools': '工具活动',
    'chat.thinking.toolActivity': '🛠️ 工具活动',
    'chat.thinking.section.reasoning': '💭 推理',
    'chat.thinking.tool.parameters': '参数：',
    'chat.thinking.tool.result': '结果：',
    'chat.thinking.tool.error': '错误：',
    'chat.thinking.tool.unknown': '未知工具',
    'chat.thinking.tool.status.pending': '待处理',
    'chat.thinking.tool.status.executing': '执行中',
    'chat.thinking.tool.status.completed': '已完成',
    'chat.thinking.tool.status.error': '错误',
    'liveMode.status.connecting': '正在连接...',
    'liveMode.status.starting': '正在启动...',
    'liveMode.status.listening': '正在聆听',
    'liveMode.status.thinking': '正在思考',
    'liveMode.status.ready': '就绪',
    'liveMode.errors.cameraDenied': '摄像头访问被拒绝',
    'liveMode.errors.screenDenied': '屏幕共享被拒绝',
    'liveMode.errors.connection': '连接错误',
    'liveMode.controls.close': '关闭实时模式',
    'liveMode.controls.mic.mute': '静音麦克风',
    'liveMode.controls.mic.unmute': '取消静音麦克风',
    'liveMode.controls.camera.on': '打开摄像头',
    'liveMode.controls.camera.off': '关闭摄像头',
    'liveMode.controls.screen.start': '共享屏幕',
    'liveMode.controls.screen.stop': '停止共享',
    'account.title': '账户',
    'account.alert.invalidImageType': '请选择一个图片文件',
    'account.alert.imageTooLarge': '请选择小于 5MB 的图片',
    'account.emailFallback': '未提供邮箱',
    'account.memberSince': '成员自',
    'account.theme': '主题',
    'account.themeDefault': '默认',
    'account.status': '状态',
    'account.statusAdmin': '管理员',
    'account.statusMember': '成员',
    'account.button.switchToAdmin': '切换到管理员',
    'account.button.logoutAdmin': '退出管理员',
    'account.button.signOut': '退出登录',
    'workspace.title': '模型',
    'workspace.searchPlaceholder': '搜索模型...',
    'workspace.button.newModel': '新建模型',
    'workspace.model.baseLabel': '基于：',
    'workspace.model.byLabel': '作者',
    'workspace.actions.edit': '编辑',
    'workspace.actions.moreOptions': '更多选项',
    'workspace.modal.titleEdit': '编辑模型',
    'workspace.modal.titleCreate': '创建新模型',
    'workspace.modal.fieldName': '模型名称',
    'workspace.modal.fieldDescription': '描述',
    'workspace.modal.fieldAvatar': '头像',
    'workspace.modal.fieldBaseModel': '基础模型',
    'workspace.modal.helperBaseModel': '选择该自定义模型应使用的 AI 模型',
    'workspace.modal.fieldSystemPrompt': '系统提示',
    'workspace.modal.placeholderExamples': '如：代码助手、创意写手',
    'workspace.modal.placeholderDescription': '简要描述该模型擅长的内容...',
    'workspace.modal.placeholderSystemPrompt': '输入定义该模型行为的系统提示...',
    'workspace.modal.status.loadingModels': '正在加载模型...',
    'workspace.modal.button.delete': '删除模型',
    'workspace.modal.button.cancel': '取消',
    'workspace.modal.button.save': '保存更改',
    'workspace.modal.button.create': '创建模型',
    'workspace.baseModelFallback': '未知',
    'media.title': '媒体',
    'media.placeholder': '媒体页的内容将在此处呈现。',
    'flowchart.titleSuffix': '流程图',
    'flowchart.subtitle': '构建、拖放或上传',
    'flowchart.sidebar.nodesLabel': '节点',
    'flowchart.sidebar.helper': '拖动到画布上,或双击节点条以放置到中心。',
    'flowchart.sidebar.dragOrDouble': '拖动到画布上,或双击以添加到中心',
    'flowchart.node.start': '开始',
    'flowchart.node.process': '处理',
    'flowchart.node.decision': '决策',
    'flowchart.node.end': '结束',
    'flowchart.toolbar.save': '保存并插入',
    'flowchart.toolbar.clear': '清除',
    'flowchart.toolbar.upload': '上传',
    'flowchart.toolbar.layout': '自动布局',
    'flowchart.empty.title': '构建流程图',
    'flowchart.empty.description': '从左侧拖动节点,或点击上传以引入您自己的图像或 JSON。通过在节点的连接点之间拖动来连接节点。双击节点以重命名。',
    'flowchart.error.exportFailed': '导出失败。',
    'flowchart.error.empty': '保存前请至少添加一个节点。',
    'flowchart.error.invalidJson': '无法读取 JSON 文件。',
    'flowchart.error.unsupportedType': '不支持的文件类型。请使用图像或 JSON。',
    'flowchart.error.aiParseFailed': '无法读取 AI 生成的流程图说明。',
    'graph.titleSuffix': '图表',
    'graph.placeholder': '输入表达式...',
    'graph.button.addExpression': '+ 添加表达式',
    'graph.controls.reset': '重置视图',
    'graph.controls.zoomIn': '放大',
    'graph.controls.zoomOut': '缩小',
    'sandbox3d.title': 'SCULPTOR 3D',
    'sandbox3d.outliner.title': '结构 ({{count}})',
    'sandbox3d.gizmoHint': '用鼠标绕转 • 单击选择 • 拖拽控制器移动',
    'sandbox3d.toolbar.addBox': '+ 盒子',
    'sandbox3d.toolbar.addSphere': '+ 球体',
    'sandbox3d.toolbar.addCylinder': '+ 圆柱',
    'sandbox3d.toolbar.addTorus': '+ 圆环',
    'sandbox3d.toolbar.delete': '删除',
    'sandbox3d.toolbar.save': '保存',
    'sandbox3d.section.properties': '属性',
    'sandbox3d.section.transform': '变换',
    'sandbox3d.section.material': '材质',
    'sandbox3d.label.position': '位置',
    'sandbox3d.label.rotation': '旋转',
    'sandbox3d.label.scale': '缩放',
    'sandbox3d.label.color': '颜色',
    'sandbox3d.label.hex': '十六进制',
    'sandbox3d.noObjectSelected': '未选中对象',
    'sandbox3d.types.box': '盒子',
    'sandbox3d.types.sphere': '球体',
    'sandbox3d.types.cylinder': '圆柱',
    'sandbox3d.types.torus': '圆环',
    'equation.title': '公式编辑器',
    'equation.preview.hint': '自然输入数学表达式...（如 "1/2", "sqrt(x)", "alpha"）',
    'equation.input.placeholder': '在此输入数学表达式，如 "x^2 + y^2 = r^2" 或 "1/2"',
    'equation.preview.typing': '正在输入："{{input}}" → 显示为 LaTeX',
    'equation.button.cancel': '取消',
    'equation.button.insert': '插入公式',
    'whiteboard.tool.pencil': '画笔',
    'whiteboard.tool.square': '方形',
    'whiteboard.tool.circle': '圆形',
    'whiteboard.tool.line': '直线',
    'whiteboard.tool.text': '文本',
    'whiteboard.tool.eraser': '橡皮擦',
    'whiteboard.tool.undo': '撤销',
    'whiteboard.tool.redo': '重做',
    'whiteboard.tool.clear': '清除',
    'whiteboard.action.export': '导出',
    'whiteboard.action.send': '发送',
    'imageSelector.label': '图像：',
    'imageSelector.placeholder': '选择模型',
    'settings.title': '设置',
    'settings.close': '关闭',
    'settings.saveButton': '保存更改',
    'settings.nav.general': '通用',
    'settings.nav.appearance': '外观',
    'settings.nav.interface': '界面',
    'settings.nav.chats': '聊天',
    'settings.nav.accessibility': '辅助功能',
    'settings.nav.developer': '开发者',
    'settings.nav.about': '关于',
    'settings.sections.general': '通用',
    'settings.sections.appearance': '外观',
    'settings.sections.interface': '界面',
    'settings.sections.chats': '聊天设置',
    'settings.sections.accessibility': '辅助功能',
    'settings.sections.developer': '开发者',
    'settings.sections.about': '关于',
    'settings.general.theme.label': '主题',
    'settings.general.language.label': '语言',
    'settings.general.notifications.label': '通知',
    'settings.themeOptions.light': '浅色',
    'settings.themeOptions.dark': '深色',
    'settings.themeOptions.oled': 'OLED',
    'settings.themeOptions.ocean': '海洋',
    'settings.themeOptions.forest': '森林',
    'settings.themeOptions.sunset': '日落',
    'settings.themeOptions.sunrise': '日出',
    'settings.themeOptions.pride': '骄傲',
    'settings.themeOptions.trans': '跨性别',
    'settings.themeOptions.bisexual': '双性',
    'settings.themeOptions.lakeside': '湖畔',
    'settings.themeOptions.retro': '复古',
    'settings.themeOptions.custom': '自定义',
    'settings.languageOptions.en-US': 'English (US)',
    'settings.languageOptions.fr': 'Français',
    'settings.languageOptions.es': 'Español',
    'settings.languageOptions.de': 'Deutsch',
    'settings.languageOptions.zh': '中文',
    'settings.appearance.fontSize.label': '字体大小',
    'settings.fontSize.small': '小',
    'settings.fontSize.medium': '中',
    'settings.fontSize.large': '大',
    'settings.appearance.fontFamily.label': '字体',
    'settings.fontFamily.system': '系统默认',
    'settings.fontFamily.inter': 'Space Mono',
    'settings.fontFamily.roboto': 'Roboto',
    'settings.fontFamily.opensans': 'Open Sans',
    'settings.fontFamily.montserrat': 'Montserrat',
    'settings.fontFamily.lato': 'Lato',
    'settings.fontFamily.caveat': 'Caveat',
    'settings.fontFamily.georgia': 'Georgia',
    'settings.fontFamily.merriweather': 'Merriweather',
    'settings.appearance.sidebarStyle.label': '侧边栏样式',
    'settings.appearance.sidebarStyle.floating': '浮动',
    'settings.appearance.sidebarStyle.traditional': '经典',
    'settings.appearance.sidebarStyle.description': '可选择圆角浮动侧边栏或贴边的传统侧边栏。',
    'settings.appearance.accent.color': '强调颜色',
    'settings.appearance.accent.description': '强调颜色会更新界面中的按钮、气泡、开关和其他高亮元素。',
    'settings.chats.profiles.toggleVisibility.label': '切换个人资料图标可见性',
    'settings.chats.profiles.toggleVisibility.description': '在聊天中显示个人资料图标',
    'settings.chats.features.label': '消息功能',
    'settings.chats.features.timestamps': '显示时间戳',
    'settings.chats.features.modelIcons': '显示模型图标',
    'settings.chats.features.codeHighlighting': '启用代码高亮',
    'settings.chats.sending.label': '消息发送',
    'settings.chats.sending.sendWithEnter': '按 Enter 发送（Shift+Enter 换行）',
    'settings.chats.alignment.label': '消息对齐',
    'settings.chats.alignment.left': '左对齐',
    'settings.chats.alignment.right': '右对齐',
    'settings.interface.layout.label': '布局',
    'settings.interface.layout.autoCollapse': '聊天时自动收起侧边栏',
    'settings.interface.layout.focusMode': '专注模式（输入时隐藏界面）',
    'settings.interface.layout.showGreeting': '在空白聊天中显示问候语',
    'settings.interface.bubbles.label': '消息气泡',
    'settings.interface.bubbles.modern': '现代（圆角）',
    'settings.interface.bubbles.classic': '经典（矩形）',
    'settings.interface.bubbles.minimal': '极简（无气泡）',
    'settings.interface.spacing.label': '消息间距',
    'settings.interface.spacing.compact': '紧凑',
    'settings.interface.spacing.comfortable': '适中',
    'settings.interface.spacing.spacious': '宽松',
    'settings.accessibility.visual.label': '视觉舒适度',
    'settings.accessibility.visual.highContrast': '高对比度模式',
    'settings.accessibility.visual.reducedMotion': '减少动画和动效',
    'settings.accessibility.textSpacing.label': '文本行距',
    'settings.accessibility.textSpacing.normal': '正常',
    'settings.accessibility.textSpacing.relaxed': '宽松',
    'settings.accessibility.textSpacing.loose': '加宽',
    'settings.developer.onboarding.label': '新手引导',
    'settings.developer.onboarding.description': '重置新手引导以重新播放欢迎教程。',
    'settings.developer.onboarding.restart': '重新开始引导',
    'settings.about.logoAlt.default': 'Sculptor 标志',
    'settings.about.logoAlt.lakeside': 'Andromeda 标志',
    'settings.about.logoTitle.default': 'Sculptor',
    'settings.about.logoTitle.lakeside': 'Andromeda',
    'settings.about.madeWith': '倾注',
    'settings.about.prideWord': '骄傲',
    'settings.about.teamMessage': '来自 Andromeda 团队，致以 ❤️',
    'settings.about.version': 'Sculptor Alpha 0.0.6',
    'settings.mobile.chatBehavior': '聊天行为',
    'settings.mobile.themeDescription': '选择你偏好的配色方案',
    'settings.mobile.fontSizeDescription': '调整字体大小以提升可读性',
    'settings.mobile.messageStyle.label': '消息样式',
    'settings.mobile.messageStyle.description': '设置聊天气泡的外观',
    'settings.mobile.sendWithEnter.title': '按 Enter 发送',
    'settings.mobile.sendWithEnter.description': '按 Enter 键发送消息',
    'settings.mobile.timestamps.title': '显示时间戳',
    'settings.mobile.timestamps.description': '在每条消息下方显示时间',
    'settings.mobile.modelIcons.title': '显示模型图标',
    'settings.mobile.modelIcons.description': '在回复旁显示 AI 模型头像',
    'settings.mobile.greeting.title': '显示问候语',
    'settings.mobile.greeting.description': '在空白聊天中显示欢迎信息',
    'settings.mobile.codeHighlighting.title': '代码高亮',
    'settings.mobile.codeHighlighting.description': '为代码块启用语法高亮',
    'settings.mobile.accessibility.highContrastDescription': '提高对比度以增强可读性',
    'settings.mobile.accessibility.reducedMotionDescription': '减少动画和过渡效果'
  }
};

const languageNames = {
  'en-US': 'English',
  fr: 'French',
  es: 'Spanish',
  de: 'German',
  zh: 'Chinese'
};

const nativeLanguageNames = {
  'en-US': 'English (US)',
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
  zh: '中文'
};

export const translateText = (language, key, fallback, variables = {}) => {
  const langMap = translations[language] || translations['en-US'];
  const defaultMap = translations['en-US'];
  let template = langMap[key] ?? defaultMap[key] ?? fallback ?? key;

  if (!template) {
    return '';
  }

  let translated = template;
  Object.keys(variables).forEach(variableKey => {
    const value = variables[variableKey];
    const regex = new RegExp(`{{\\s*${variableKey}\\s*}}`, 'g');
    translated = translated.replace(regex, value);
  });

  return translated;
};

export const getLanguageDisplayName = (language, { native = false } = {}) => {
  if (native) {
    return nativeLanguageNames[language] || nativeLanguageNames['en-US'];
  }
  return languageNames[language] || languageNames['en-US'];
};

export default translations;
